/* tslint:disable */
/* eslint-disable */
/**
 * Content-A service
 * Content Service API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-Content_Team@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AccordionAllOfModel
 */
export interface AccordionAllOfModel {
    /**
     * 
     * @type {Array<AccordionItemModel>}
     * @memberof AccordionAllOfModel
     */
    'items'?: Array<AccordionItemModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof AccordionAllOfModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {string}
     * @memberof AccordionAllOfModel
     */
    'placement'?: string;
}
/**
 * 
 * @export
 * @interface AccordionItemModel
 */
export interface AccordionItemModel {
    /**
     * 
     * @type {AnalyticsModel}
     * @memberof AccordionItemModel
     */
    'analytics': AnalyticsModel;
    /**
     * 
     * @type {string}
     * @memberof AccordionItemModel
     */
    'id': string;
    /**
     * 
     * @type {InstrumentationModel}
     * @memberof AccordionItemModel
     */
    'instrumentation': InstrumentationModel;
    /**
     * 
     * @type {number}
     * @memberof AccordionItemModel
     */
    'itemPosition'?: number;
    /**
     * 
     * @type {CopyModel}
     * @memberof AccordionItemModel
     */
    'itemText'?: CopyModel;
    /**
     * 
     * @type {string}
     * @memberof AccordionItemModel
     */
    'itemTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccordionItemModel
     */
    'placement'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccordionItemModel
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface AccordionModel
 */
export interface AccordionModel extends ComponentModel {
    /**
     * 
     * @type {Array<AccordionItemModel>}
     * @memberof AccordionModel
     */
    'items'?: Array<AccordionItemModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof AccordionModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {string}
     * @memberof AccordionModel
     */
    'placement'?: string;
}
/**
 * 
 * @export
 * @interface AdTileModel
 */
export interface AdTileModel {
    /**
     * 
     * @type {AnalyticsModel}
     * @memberof AdTileModel
     */
    'analytics': AnalyticsModel;
    /**
     * 
     * @type {string}
     * @memberof AdTileModel
     */
    'id': string;
    /**
     * 
     * @type {ImagesModel}
     * @memberof AdTileModel
     */
    'images'?: ImagesModel;
    /**
     * 
     * @type {LinkModel}
     * @memberof AdTileModel
     */
    'link'?: LinkModel;
    /**
     * 
     * @type {string}
     * @memberof AdTileModel
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface AdTileSetAllOfModel
 */
export interface AdTileSetAllOfModel {
    /**
     * 
     * @type {Array<AdTileModel>}
     * @memberof AdTileSetAllOfModel
     */
    'items'?: Array<AdTileModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof AdTileSetAllOfModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {boolean}
     * @memberof AdTileSetAllOfModel
     */
    'useDivider'?: boolean;
}
/**
 * 
 * @export
 * @interface AdTileSetModel
 */
export interface AdTileSetModel extends ComponentModel {
    /**
     * 
     * @type {Array<AdTileModel>}
     * @memberof AdTileSetModel
     */
    'items'?: Array<AdTileModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof AdTileSetModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {boolean}
     * @memberof AdTileSetModel
     */
    'useDivider'?: boolean;
}
/**
 * 
 * @export
 * @interface AnalyticsModel
 */
export interface AnalyticsModel {
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'creativeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'creativeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'data-analytics-audience-id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'data-analytics-content-source': string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'data-analytics-dimension119'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'data-analytics-dimension120'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'data-analytics-dimension121'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'data-analytics-dimension123'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'data-analytics-experiment-id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'data-analytics-permanent-creative-id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'data-analytics-source-view'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'data-analytics-target-segment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'data-analytics-treatment-id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'eventLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'listType'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'pageName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'pageType'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'placementSlotUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'position'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'promoName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'widgetId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'widgetType'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsModel
     */
    'widgetTypeValue'?: string;
}
/**
 * 
 * @export
 * @interface ArticleCarouselAllOfModel
 */
export interface ArticleCarouselAllOfModel {
    /**
     * 
     * @type {Array<ArticleItemModel>}
     * @memberof ArticleCarouselAllOfModel
     */
    'items'?: Array<ArticleItemModel>;
    /**
     * 
     * @type {Array<ConstraintModel>}
     * @memberof ArticleCarouselAllOfModel
     */
    'constraints'?: Array<ConstraintModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof ArticleCarouselAllOfModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {HeaderModel}
     * @memberof ArticleCarouselAllOfModel
     */
    'subHeader'?: HeaderModel;
    /**
     * 
     * @type {LinkModel}
     * @memberof ArticleCarouselAllOfModel
     */
    'link'?: LinkModel;
    /**
     * 
     * @type {Array<string>}
     * @memberof ArticleCarouselAllOfModel
     */
    'displayToggles'?: Array<string>;
    /**
     * 
     * @type {ContentThemeModel}
     * @memberof ArticleCarouselAllOfModel
     */
    'theme'?: ContentThemeModel;
    /**
     * 
     * @type {string}
     * @memberof ArticleCarouselAllOfModel
     */
    'recipeType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleCarouselAllOfModel
     */
    'layout'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleCarouselAllOfModel
     */
    'overlineText'?: string;
}
/**
 * 
 * @export
 * @interface ArticleCarouselModel
 */
export interface ArticleCarouselModel extends ComponentModel {
    /**
     * 
     * @type {Array<ArticleItemModel>}
     * @memberof ArticleCarouselModel
     */
    'items': Array<ArticleItemModel>;
    /**
     * 
     * @type {Array<ConstraintModel>}
     * @memberof ArticleCarouselModel
     */
    'constraints'?: Array<ConstraintModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof ArticleCarouselModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {HeaderModel}
     * @memberof ArticleCarouselModel
     */
    'subHeader'?: HeaderModel;
    /**
     * 
     * @type {LinkModel}
     * @memberof ArticleCarouselModel
     */
    'link'?: LinkModel;
    /**
     * 
     * @type {Array<string>}
     * @memberof ArticleCarouselModel
     */
    'displayToggles'?: Array<string>;
    /**
     * 
     * @type {ContentThemeModel}
     * @memberof ArticleCarouselModel
     */
    'theme'?: ContentThemeModel;
    /**
     * 
     * @type {string}
     * @memberof ArticleCarouselModel
     */
    'recipeType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleCarouselModel
     */
    'layout'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleCarouselModel
     */
    'overlineText'?: string;
}
/**
 * 
 * @export
 * @interface ArticleItemAllOfModel
 */
export interface ArticleItemAllOfModel {
    /**
     * 
     * @type {string}
     * @memberof ArticleItemAllOfModel
     */
    'articleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleItemAllOfModel
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleItemAllOfModel
     */
    'url'?: string;
    /**
     * 
     * @type {ImagesModel}
     * @memberof ArticleItemAllOfModel
     */
    'images'?: ImagesModel;
    /**
     * 
     * @type {string}
     * @memberof ArticleItemAllOfModel
     */
    'author'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleItemAllOfModel
     */
    'authorImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleItemAllOfModel
     */
    'sponsoredBy'?: string;
    /**
     * 
     * @type {LogoIconModel}
     * @memberof ArticleItemAllOfModel
     */
    'logo'?: LogoIconModel;
    /**
     * 
     * @type {string}
     * @memberof ArticleItemAllOfModel
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleItemAllOfModel
     */
    'publishedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleItemAllOfModel
     */
    'wistiaId'?: string;
}
/**
 * 
 * @export
 * @interface ArticleItemModel
 */
export interface ArticleItemModel extends ComponentModel {
    /**
     * 
     * @type {string}
     * @memberof ArticleItemModel
     */
    'articleId': string;
    /**
     * 
     * @type {string}
     * @memberof ArticleItemModel
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ArticleItemModel
     */
    'url': string;
    /**
     * 
     * @type {ImagesModel}
     * @memberof ArticleItemModel
     */
    'images'?: ImagesModel;
    /**
     * 
     * @type {string}
     * @memberof ArticleItemModel
     */
    'author'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleItemModel
     */
    'authorImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleItemModel
     */
    'sponsoredBy'?: string;
    /**
     * 
     * @type {LogoIconModel}
     * @memberof ArticleItemModel
     */
    'logo'?: LogoIconModel;
    /**
     * 
     * @type {string}
     * @memberof ArticleItemModel
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleItemModel
     */
    'publishedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleItemModel
     */
    'wistiaId'?: string;
}
/**
 * 
 * @export
 * @interface BannerAllOfModel
 */
export interface BannerAllOfModel {
    /**
     * 
     * @type {HeaderModel}
     * @memberof BannerAllOfModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {ImagesModel}
     * @memberof BannerAllOfModel
     */
    'images'?: ImagesModel;
    /**
     * 
     * @type {LinkModel}
     * @memberof BannerAllOfModel
     */
    'link'?: LinkModel;
}
/**
 * 
 * @export
 * @interface BannerCarouselAllOfModel
 */
export interface BannerCarouselAllOfModel {
    /**
     * 
     * @type {Array<BannerModel>}
     * @memberof BannerCarouselAllOfModel
     */
    'items'?: Array<BannerModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof BannerCarouselAllOfModel
     */
    'header'?: HeaderModel;
}
/**
 * 
 * @export
 * @interface BannerCarouselModel
 */
export interface BannerCarouselModel extends ComponentModel {
    /**
     * 
     * @type {Array<BannerModel>}
     * @memberof BannerCarouselModel
     */
    'items'?: Array<BannerModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof BannerCarouselModel
     */
    'header'?: HeaderModel;
}
/**
 * 
 * @export
 * @interface BannerModel
 */
export interface BannerModel extends ComponentModel {
    /**
     * 
     * @type {HeaderModel}
     * @memberof BannerModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {ImagesModel}
     * @memberof BannerModel
     */
    'images'?: ImagesModel;
    /**
     * 
     * @type {LinkModel}
     * @memberof BannerModel
     */
    'link'?: LinkModel;
}
/**
 * 
 * @export
 * @interface ButtonModel
 */
export interface ButtonModel {
    /**
     * 
     * @type {string}
     * @memberof ButtonModel
     */
    'accText'?: string;
    /**
     * 
     * @type {string}
     * @memberof ButtonModel
     */
    'lineOne'?: string;
    /**
     * 
     * @type {string}
     * @memberof ButtonModel
     */
    'lineTwo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ButtonModel
     */
    'style'?: string;
    /**
     * 
     * @type {string}
     * @memberof ButtonModel
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof ButtonModel
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ButtonModel
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface ComponentModel
 */
export interface ComponentModel {
    /**
     * 
     * @type {AnalyticsModel}
     * @memberof ComponentModel
     */
    'analytics': AnalyticsModel;
    /**
     * 
     * @type {string}
     * @memberof ComponentModel
     */
    'id': string;
    /**
     * 
     * @type {InstrumentationModel}
     * @memberof ComponentModel
     */
    'instrumentation'?: InstrumentationModel;
    /**
     * 
     * @type {string}
     * @memberof ComponentModel
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ConstraintModel
 */
export interface ConstraintModel {
    /**
     * 
     * @type {boolean}
     * @memberof ConstraintModel
     */
    'status': boolean;
    /**
     * 
     * @type {string}
     * @memberof ConstraintModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof ConstraintModel
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface ContentBackgroundModel
 */
export interface ContentBackgroundModel {
    /**
     * 
     * @type {string}
     * @memberof ContentBackgroundModel
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentBackgroundModel
     */
    'tileUrl'?: string;
}
/**
 * 
 * @export
 * @interface ContentButtonModel
 */
export interface ContentButtonModel {
    /**
     * 
     * @type {string}
     * @memberof ContentButtonModel
     */
    'accText'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentButtonModel
     */
    'lineOne'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentButtonModel
     */
    'lineTwo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentButtonModel
     */
    'style'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentButtonModel
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentButtonModel
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentButtonModel
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface ContentCardAllOfModel
 */
export interface ContentCardAllOfModel {
    /**
     * 
     * @type {CopyModel}
     * @memberof ContentCardAllOfModel
     */
    'body'?: CopyModel;
    /**
     * 
     * @type {ImageVariationModel}
     * @memberof ContentCardAllOfModel
     */
    'image'?: ImageVariationModel;
}
/**
 * 
 * @export
 * @interface ContentCardModel
 */
export interface ContentCardModel extends DeckCardModel {
    /**
     * 
     * @type {CopyModel}
     * @memberof ContentCardModel
     */
    'body'?: CopyModel;
    /**
     * 
     * @type {ImageVariationModel}
     * @memberof ContentCardModel
     */
    'image'?: ImageVariationModel;
}
/**
 * 
 * @export
 * @interface ContentCopyModel
 */
export interface ContentCopyModel {
    /**
     * 
     * @type {string}
     * @memberof ContentCopyModel
     */
    'alignment'?: string;
    /**
     * 
     * @type {PersonalizedTextBlockModel}
     * @memberof ContentCopyModel
     */
    'personalizedTextBlock'?: PersonalizedTextBlockModel;
    /**
     * 
     * @type {string}
     * @memberof ContentCopyModel
     */
    'richText'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentCopyModel
     */
    'size'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentCopyModel
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentCopyModel
     */
    'textColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentCopyModel
     */
    'textStyle'?: string;
}
/**
 * 
 * @export
 * @interface ContentFooterModel
 */
export interface ContentFooterModel {
    /**
     * 
     * @type {string}
     * @memberof ContentFooterModel
     */
    'alignment'?: string;
    /**
     * 
     * @type {Array<ContentButtonModel>}
     * @memberof ContentFooterModel
     */
    'ctaButtons': Array<ContentButtonModel>;
    /**
     * 
     * @type {string}
     * @memberof ContentFooterModel
     */
    'richText'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentFooterModel
     */
    'textStyle'?: string;
}
/**
 * 
 * @export
 * @interface ContentImageModel
 */
export interface ContentImageModel {
    /**
     * 
     * @type {string}
     * @memberof ContentImageModel
     */
    'accCaption'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentImageModel
     */
    'accLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentImageModel
     */
    'alignment'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentImageModel
     */
    'altText'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentImageModel
     */
    'height'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentImageModel
     */
    'imageType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentImageModel
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentImageModel
     */
    'position'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentImageModel
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentImageModel
     */
    'width'?: string;
}
/**
 * 
 * @export
 * @interface ContentImageVariationModel
 */
export interface ContentImageVariationModel {
    /**
     * 
     * @type {string}
     * @memberof ContentImageVariationModel
     */
    'altText'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentImageVariationModel
     */
    'baseUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentImageVariationModel
     */
    'fileExtension'?: string;
    /**
     * 
     * @type {number}
     * @memberof ContentImageVariationModel
     */
    'height'?: number;
    /**
     * 
     * @type {string}
     * @memberof ContentImageVariationModel
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentImageVariationModel
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentImageVariationModel
     */
    'version'?: string;
    /**
     * 
     * @type {number}
     * @memberof ContentImageVariationModel
     */
    'width'?: number;
}
/**
 * 
 * @export
 * @interface ContentImageVariationsModel
 */
export interface ContentImageVariationsModel {
    /**
     * 
     * @type {ContentImageVariationModel}
     * @memberof ContentImageVariationsModel
     */
    'default'?: ContentImageVariationModel;
    /**
     * 
     * @type {ContentImageVariationModel}
     * @memberof ContentImageVariationsModel
     */
    'extraSmall'?: ContentImageVariationModel;
    /**
     * 
     * @type {ContentImageVariationModel}
     * @memberof ContentImageVariationsModel
     */
    'large'?: ContentImageVariationModel;
    /**
     * 
     * @type {ContentImageVariationModel}
     * @memberof ContentImageVariationsModel
     */
    'medium'?: ContentImageVariationModel;
    /**
     * 
     * @type {ContentImageVariationModel}
     * @memberof ContentImageVariationsModel
     */
    'small'?: ContentImageVariationModel;
}
/**
 * 
 * @export
 * @interface ContentImagesModel
 */
export interface ContentImagesModel {
    /**
     * 
     * @type {string}
     * @memberof ContentImagesModel
     */
    'accCaption'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentImagesModel
     */
    'accLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentImagesModel
     */
    'alignment'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentImagesModel
     */
    'altText'?: string;
    /**
     * 
     * @type {ContentBackgroundModel}
     * @memberof ContentImagesModel
     */
    'background'?: ContentBackgroundModel;
    /**
     * 
     * @type {Array<ContentImageModel>}
     * @memberof ContentImagesModel
     */
    'default': Array<ContentImageModel>;
    /**
     * 
     * @type {Array<ContentImageModel>}
     * @memberof ContentImagesModel
     */
    'extraSmall': Array<ContentImageModel>;
    /**
     * 
     * @type {Array<ContentImageModel>}
     * @memberof ContentImagesModel
     */
    'large': Array<ContentImageModel>;
    /**
     * 
     * @type {Array<ContentImageModel>}
     * @memberof ContentImagesModel
     */
    'medium': Array<ContentImageModel>;
    /**
     * 
     * @type {Array<ContentImageModel>}
     * @memberof ContentImagesModel
     */
    'small': Array<ContentImageModel>;
    /**
     * 
     * @type {ContentImageVariationsModel}
     * @memberof ContentImagesModel
     */
    'variations'?: ContentImageVariationsModel;
}
/**
 * 
 * @export
 * @interface ContentPageModel
 */
export interface ContentPageModel {
    /**
     * 
     * @type {MetadataModel}
     * @memberof ContentPageModel
     */
    'metadata'?: MetadataModel;
    /**
     * 
     * @type {Array<ZoneModel>}
     * @memberof ContentPageModel
     */
    'zones'?: Array<ZoneModel>;
}
/**
 * 
 * @export
 * @interface ContentThemeModel
 */
export interface ContentThemeModel {
    /**
     * 
     * @type {string}
     * @memberof ContentThemeModel
     */
    'backgroundEnd'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentThemeModel
     */
    'backgroundHover'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentThemeModel
     */
    'backgroundPressed'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentThemeModel
     */
    'backgroundStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentThemeModel
     */
    'borderColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentThemeModel
     */
    'itemVariant'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentThemeModel
     */
    'textColor'?: string;
}
/**
 * 
 * @export
 * @interface ContextCardModel
 */
export interface ContextCardModel {
    /**
     * 
     * @type {ContentCopyModel}
     * @memberof ContextCardModel
     */
    'body'?: ContentCopyModel;
    /**
     * 
     * @type {LinkModel}
     * @memberof ContextCardModel
     */
    'cta'?: LinkModel;
    /**
     * 
     * @type {LogoIconModel}
     * @memberof ContextCardModel
     */
    'icon'?: LogoIconModel;
    /**
     * 
     * @type {ContentImagesModel}
     * @memberof ContextCardModel
     */
    'images'?: ContentImagesModel;
    /**
     * 
     * @type {LogoIconModel}
     * @memberof ContextCardModel
     */
    'logo'?: LogoIconModel;
    /**
     * 
     * @type {ContentThemeModel}
     * @memberof ContextCardModel
     */
    'theme'?: ContentThemeModel;
    /**
     * 
     * @type {ContentCopyModel}
     * @memberof ContextCardModel
     */
    'title'?: ContentCopyModel;
    /**
     * 
     * @type {VideoModel}
     * @memberof ContextCardModel
     */
    'video'?: VideoModel;
}
/**
 * 
 * @export
 * @interface CopyModel
 */
export interface CopyModel {
    /**
     * 
     * @type {string}
     * @memberof CopyModel
     */
    'alignment'?: string;
    /**
     * 
     * @type {string}
     * @memberof CopyModel
     */
    'richText'?: string;
    /**
     * 
     * @type {string}
     * @memberof CopyModel
     */
    'size'?: string;
    /**
     * 
     * @type {string}
     * @memberof CopyModel
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof CopyModel
     */
    'textColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof CopyModel
     */
    'textStyle'?: string;
}
/**
 * 
 * @export
 * @interface CoverCardAllOfModel
 */
export interface CoverCardAllOfModel {
    /**
     * 
     * @type {DeckAuthorModel}
     * @memberof CoverCardAllOfModel
     */
    'author'?: DeckAuthorModel;
    /**
     * 
     * @type {CopyModel}
     * @memberof CoverCardAllOfModel
     */
    'headline'?: CopyModel;
    /**
     * 
     * @type {ImageVariationModel}
     * @memberof CoverCardAllOfModel
     */
    'image'?: ImageVariationModel;
    /**
     * 
     * @type {string}
     * @memberof CoverCardAllOfModel
     */
    'overlineText'?: string;
}
/**
 * 
 * @export
 * @interface CoverCardModel
 */
export interface CoverCardModel extends DeckCardModel {
    /**
     * 
     * @type {DeckAuthorModel}
     * @memberof CoverCardModel
     */
    'author'?: DeckAuthorModel;
    /**
     * 
     * @type {CopyModel}
     * @memberof CoverCardModel
     */
    'headline'?: CopyModel;
    /**
     * 
     * @type {ImageVariationModel}
     * @memberof CoverCardModel
     */
    'image'?: ImageVariationModel;
    /**
     * 
     * @type {string}
     * @memberof CoverCardModel
     */
    'overlineText'?: string;
}
/**
 * 
 * @export
 * @interface CustomerInsightsModel
 */
export interface CustomerInsightsModel {
    /**
     * 
     * @type {LastOrderInsightModel}
     * @memberof CustomerInsightsModel
     */
    'lastOrderInsight'?: LastOrderInsightModel;
}
/**
 * @type DeckAllOfItemsInnerModel
 * @export
 */
export type DeckAllOfItemsInnerModel = ContentCardModel | CoverCardModel | ShopCardModel;

/**
 * 
 * @export
 * @interface DeckAllOfModel
 */
export interface DeckAllOfModel {
    /**
     * 
     * @type {Array<DeckAllOfItemsInnerModel>}
     * @memberof DeckAllOfModel
     */
    'items'?: Array<DeckAllOfItemsInnerModel>;
    /**
     * 
     * @type {string}
     * @memberof DeckAllOfModel
     */
    'recipeType'?: string;
}
/**
 * 
 * @export
 * @interface DeckAuthorModel
 */
export interface DeckAuthorModel {
    /**
     * 
     * @type {ImageVariationModel}
     * @memberof DeckAuthorModel
     */
    'image'?: ImageVariationModel;
    /**
     * 
     * @type {string}
     * @memberof DeckAuthorModel
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface DeckCardModel
 */
export interface DeckCardModel {
    /**
     * 
     * @type {AnalyticsModel}
     * @memberof DeckCardModel
     */
    'analytics': AnalyticsModel;
    /**
     * 
     * @type {string}
     * @memberof DeckCardModel
     */
    'cardType': string;
    /**
     * 
     * @type {string}
     * @memberof DeckCardModel
     */
    'id': string;
    /**
     * 
     * @type {InstrumentationModel}
     * @memberof DeckCardModel
     */
    'instrumentation'?: InstrumentationModel;
    /**
     * 
     * @type {string}
     * @memberof DeckCardModel
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface DeckModel
 */
export interface DeckModel extends ComponentModel {
    /**
     * 
     * @type {Array<DeckAllOfItemsInnerModel>}
     * @memberof DeckModel
     */
    'items'?: Array<DeckAllOfItemsInnerModel>;
    /**
     * 
     * @type {string}
     * @memberof DeckModel
     */
    'recipeType'?: string;
}
/**
 * 
 * @export
 * @interface HeaderModel
 */
export interface HeaderModel {
    /**
     * 
     * @type {string}
     * @memberof HeaderModel
     */
    'accText'?: string;
    /**
     * 
     * @type {string}
     * @memberof HeaderModel
     */
    'alignment'?: string;
    /**
     * 
     * @type {string}
     * @memberof HeaderModel
     */
    'linkText'?: string;
    /**
     * 
     * @type {string}
     * @memberof HeaderModel
     */
    'richText'?: string;
    /**
     * 
     * @type {string}
     * @memberof HeaderModel
     */
    'size'?: string;
    /**
     * 
     * @type {string}
     * @memberof HeaderModel
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof HeaderModel
     */
    'textColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof HeaderModel
     */
    'textStyle'?: string;
    /**
     * 
     * @type {string}
     * @memberof HeaderModel
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface ImageModel
 */
export interface ImageModel {
    /**
     * 
     * @type {string}
     * @memberof ImageModel
     */
    'accCaption'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageModel
     */
    'accLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageModel
     */
    'altText'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageModel
     */
    'height'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageModel
     */
    'imageType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageModel
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageModel
     */
    'originalUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageModel
     */
    'position'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageModel
     */
    'source'?: ImageModelSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof ImageModel
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageModel
     */
    'width'?: string;
}

export const ImageModelSourceEnum = {
    Dotcms: 'DOTCMS',
    Mosaic: 'MOSAIC'
} as const;

export type ImageModelSourceEnum = typeof ImageModelSourceEnum[keyof typeof ImageModelSourceEnum];

/**
 * 
 * @export
 * @interface ImageVariationModel
 */
export interface ImageVariationModel {
    /**
     * 
     * @type {string}
     * @memberof ImageVariationModel
     */
    'altText'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageVariationModel
     */
    'baseUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageVariationModel
     */
    'fileExtension'?: string;
    /**
     * 
     * @type {number}
     * @memberof ImageVariationModel
     */
    'height'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImageVariationModel
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageVariationModel
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageVariationModel
     */
    'version'?: string;
    /**
     * 
     * @type {number}
     * @memberof ImageVariationModel
     */
    'width'?: number;
}
/**
 * 
 * @export
 * @interface ImagesBackgroundModel
 */
export interface ImagesBackgroundModel {
    /**
     * 
     * @type {string}
     * @memberof ImagesBackgroundModel
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImagesBackgroundModel
     */
    'tileUrl'?: string;
}
/**
 * 
 * @export
 * @interface ImagesModel
 */
export interface ImagesModel {
    /**
     * 
     * @type {ImagesBackgroundModel}
     * @memberof ImagesModel
     */
    'background'?: ImagesBackgroundModel;
    /**
     * 
     * @type {Array<ImageModel>}
     * @memberof ImagesModel
     */
    'default'?: Array<ImageModel>;
    /**
     * 
     * @type {Array<ImageModel>}
     * @memberof ImagesModel
     */
    'extraSmall'?: Array<ImageModel>;
    /**
     * 
     * @type {Array<ImageModel>}
     * @memberof ImagesModel
     */
    'large'?: Array<ImageModel>;
    /**
     * 
     * @type {Array<ImageModel>}
     * @memberof ImagesModel
     */
    'medium'?: Array<ImageModel>;
    /**
     * 
     * @type {Array<ImageModel>}
     * @memberof ImagesModel
     */
    'small'?: Array<ImageModel>;
}
/**
 * 
 * @export
 * @interface InstrumentationModel
 */
export interface InstrumentationModel {
    /**
     * 
     * @type {InstrumentationPropertiesModel}
     * @memberof InstrumentationModel
     */
    'properties'?: InstrumentationPropertiesModel;
}
/**
 * 
 * @export
 * @interface InstrumentationProductModel
 */
export interface InstrumentationProductModel {
    /**
     * 
     * @type {boolean}
     * @memberof InstrumentationProductModel
     */
    'inStock': boolean;
    /**
     * 
     * @type {string}
     * @memberof InstrumentationProductModel
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstrumentationProductModel
     */
    'partNumber'?: string;
}
/**
 * 
 * @export
 * @interface InstrumentationPropertiesModel
 */
export interface InstrumentationPropertiesModel {
    /**
     * 
     * @type {string}
     * @memberof InstrumentationPropertiesModel
     */
    'audienceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstrumentationPropertiesModel
     */
    'contentPublisher'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstrumentationPropertiesModel
     */
    'creative'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstrumentationPropertiesModel
     */
    'destinationUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstrumentationPropertiesModel
     */
    'experimentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstrumentationPropertiesModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstrumentationPropertiesModel
     */
    'level'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstrumentationPropertiesModel
     */
    'parentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstrumentationPropertiesModel
     */
    'position'?: string;
    /**
     * 
     * @type {Array<InstrumentationProductModel>}
     * @memberof InstrumentationPropertiesModel
     */
    'products'?: Array<InstrumentationProductModel>;
    /**
     * 
     * @type {string}
     * @memberof InstrumentationPropertiesModel
     */
    'subType'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstrumentationPropertiesModel
     */
    'treatmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstrumentationPropertiesModel
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface LastOrderInsightModel
 */
export interface LastOrderInsightModel {
    /**
     * 
     * @type {string}
     * @memberof LastOrderInsightModel
     */
    'orderPlacedTimestamp'?: string;
}
/**
 * 
 * @export
 * @interface LinkModel
 */
export interface LinkModel {
    /**
     * 
     * @type {string}
     * @memberof LinkModel
     */
    'accText'?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkModel
     */
    'target'?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkModel
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkModel
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface LogoIconModel
 */
export interface LogoIconModel {
    /**
     * 
     * @type {string}
     * @memberof LogoIconModel
     */
    'markup'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogoIconModel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LogoIconModel
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogoIconModel
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface MediaPlayerConfigModel
 */
export interface MediaPlayerConfigModel {
    /**
     * 
     * @type {boolean}
     * @memberof MediaPlayerConfigModel
     */
    'autoPlay': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaPlayerConfigModel
     */
    'modal': boolean;
}
/**
 * 
 * @export
 * @interface MetadataModel
 */
export interface MetadataModel {
    /**
     * 
     * @type {string}
     * @memberof MetadataModel
     */
    'canonicalUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetadataModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetadataModel
     */
    'metaDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetadataModel
     */
    'metaTitle'?: string;
}
/**
 * 
 * @export
 * @interface MoneyModel
 */
export interface MoneyModel {
    /**
     * 
     * @type {number}
     * @memberof MoneyModel
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof MoneyModel
     */
    'currency': string;
}
/**
 * 
 * @export
 * @interface NoContentModel
 */
export interface NoContentModel extends ComponentModel {
}
/**
 * 
 * @export
 * @interface PersonalizedTextBlockModel
 */
export interface PersonalizedTextBlockModel {
    /**
     * 
     * @type {string}
     * @memberof PersonalizedTextBlockModel
     */
    'defaultMessage': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalizedTextBlockModel
     */
    'personalizedMessage': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PersonalizedTextBlockModel
     */
    'variables': Array<PersonalizedTextBlockModelVariablesEnum>;
}

export const PersonalizedTextBlockModelVariablesEnum = {
    PetName: 'PET_NAME',
    GiftcardBalance: 'GIFTCARD_BALANCE'
} as const;

export type PersonalizedTextBlockModelVariablesEnum = typeof PersonalizedTextBlockModelVariablesEnum[keyof typeof PersonalizedTextBlockModelVariablesEnum];

/**
 * 
 * @export
 * @interface PriceModel
 */
export interface PriceModel {
    /**
     * 
     * @type {PromotionModel}
     * @memberof PriceModel
     */
    'promotion'?: PromotionModel;
    /**
     * 
     * @type {Array<string>}
     * @memberof PriceModel
     */
    'treatments': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PriceModel
     */
    'type'?: string;
    /**
     * 
     * @type {MoneyModel}
     * @memberof PriceModel
     */
    'value'?: MoneyModel;
}
/**
 * 
 * @export
 * @interface PricingModel
 */
export interface PricingModel {
    /**
     * 
     * @type {boolean}
     * @memberof PricingModel
     */
    'isFirstOrderAutoshipMapEnforced': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PricingModel
     */
    'isFirstOrderAutoshipVendorExcluded': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PricingModel
     */
    'isMapEnforced': boolean;
    /**
     * 
     * @type {string}
     * @memberof PricingModel
     */
    'partNumber': string;
    /**
     * 
     * @type {MoneyModel}
     * @memberof PricingModel
     */
    'perUnitPrice'?: MoneyModel;
    /**
     * 
     * @type {string}
     * @memberof PricingModel
     */
    'priceUom'?: string;
    /**
     * 
     * @type {Array<PriceModel>}
     * @memberof PricingModel
     */
    'prices': Array<PriceModel>;
}
/**
 * 
 * @export
 * @interface ProductCarouselAllOfModel
 */
export interface ProductCarouselAllOfModel {
    /**
     * 
     * @type {Array<ProductModel>}
     * @memberof ProductCarouselAllOfModel
     */
    'items'?: Array<ProductModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof ProductCarouselAllOfModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {Array<SkuModel>}
     * @memberof ProductCarouselAllOfModel
     */
    'skus'?: Array<SkuModel>;
}
/**
 * 
 * @export
 * @interface ProductCarouselModel
 */
export interface ProductCarouselModel extends ComponentModel {
    /**
     * 
     * @type {Array<ProductModel>}
     * @memberof ProductCarouselModel
     */
    'items'?: Array<ProductModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof ProductCarouselModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {Array<SkuModel>}
     * @memberof ProductCarouselModel
     */
    'skus'?: Array<SkuModel>;
}
/**
 * 
 * @export
 * @interface ProductModel
 */
export interface ProductModel {
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'accessibilityPromoTermDetails'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'advertisedPrice'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'autoShipDiscountPercentage'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'autoShipPrice'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductModel
     */
    'bundle': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductModel
     */
    'customizable': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'deliveryMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'desktopPromoTermDetailsUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductModel
     */
    'discontinued': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'id'?: string;
    /**
     * 
     * @type {ImagesModel}
     * @memberof ProductModel
     */
    'images'?: ImagesModel;
    /**
     * 
     * @type {boolean}
     * @memberof ProductModel
     */
    'inStock': boolean;
    /**
     * 
     * @type {InstrumentationModel}
     * @memberof ProductModel
     */
    'instrumentation'?: InstrumentationModel;
    /**
     * 
     * @type {LinkModel}
     * @memberof ProductModel
     */
    'link'?: LinkModel;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'manufacturerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'mobilePromoTermDetailsUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductModel
     */
    'monetized': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductModel
     */
    'onSpecial': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'parentPartNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'partNumber'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductModel
     */
    'pharmaceutical': boolean;
    /**
     * 
     * @type {PricingModel}
     * @memberof ProductModel
     */
    'pricing'?: PricingModel;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'productName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'promoHeadlineLong'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'promoHeadlineShort'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductModel
     */
    'promoIcon': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'promoMessage'?: string;
    /**
     * 
     * @type {Array<PromotionModel>}
     * @memberof ProductModel
     */
    'promotions'?: Array<PromotionModel>;
    /**
     * 
     * @type {boolean}
     * @memberof ProductModel
     */
    'proprietary': boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductModel
     */
    'rating'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductModel
     */
    'ratingCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'strikeThroughPrice'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'type': string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductModel
     */
    'veterinaryDiet': boolean;
}
/**
 * 
 * @export
 * @interface PromotionModel
 */
export interface PromotionModel {
    /**
     * 
     * @type {MoneyModel}
     * @memberof PromotionModel
     */
    'autoshipDiscountMaxValue'?: MoneyModel;
    /**
     * 
     * @type {number}
     * @memberof PromotionModel
     */
    'autoshipDiscountPercent'?: number;
    /**
     * 
     * @type {string}
     * @memberof PromotionModel
     */
    'group'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PromotionModel
     */
    'isGreenbarEligible': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromotionModel
     */
    'isSmartshelfEligible': boolean;
    /**
     * 
     * @type {string}
     * @memberof PromotionModel
     */
    'longDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromotionModel
     */
    'promotionId': string;
    /**
     * 
     * @type {string}
     * @memberof PromotionModel
     */
    'rewardType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromotionModel
     */
    'searchDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromotionModel
     */
    'shortDescription'?: string;
}
/**
 * 
 * @export
 * @interface ShopCardAllOfModel
 */
export interface ShopCardAllOfModel {
    /**
     * 
     * @type {CopyModel}
     * @memberof ShopCardAllOfModel
     */
    'body'?: CopyModel;
    /**
     * 
     * @type {Array<ProductModel>}
     * @memberof ShopCardAllOfModel
     */
    'items'?: Array<ProductModel>;
    /**
     * 
     * @type {number}
     * @memberof ShopCardAllOfModel
     */
    'maxItems'?: number;
}
/**
 * 
 * @export
 * @interface ShopCardModel
 */
export interface ShopCardModel extends DeckCardModel {
    /**
     * 
     * @type {CopyModel}
     * @memberof ShopCardModel
     */
    'body'?: CopyModel;
    /**
     * 
     * @type {Array<ProductModel>}
     * @memberof ShopCardModel
     */
    'items'?: Array<ProductModel>;
    /**
     * 
     * @type {number}
     * @memberof ShopCardModel
     */
    'maxItems'?: number;
}
/**
 * 
 * @export
 * @interface ShopNavAllOfModel
 */
export interface ShopNavAllOfModel {
    /**
     * 
     * @type {Array<ShopNavItemModel>}
     * @memberof ShopNavAllOfModel
     */
    'items'?: Array<ShopNavItemModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof ShopNavAllOfModel
     */
    'header'?: HeaderModel;
}
/**
 * 
 * @export
 * @interface ShopNavItemModel
 */
export interface ShopNavItemModel {
    /**
     * 
     * @type {AnalyticsModel}
     * @memberof ShopNavItemModel
     */
    'analytics': AnalyticsModel;
    /**
     * 
     * @type {HeaderModel}
     * @memberof ShopNavItemModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {string}
     * @memberof ShopNavItemModel
     */
    'id': string;
    /**
     * 
     * @type {ImagesModel}
     * @memberof ShopNavItemModel
     */
    'images'?: ImagesModel;
    /**
     * 
     * @type {LinkModel}
     * @memberof ShopNavItemModel
     */
    'link'?: LinkModel;
    /**
     * 
     * @type {HeaderModel}
     * @memberof ShopNavItemModel
     */
    'subheader'?: HeaderModel;
    /**
     * 
     * @type {string}
     * @memberof ShopNavItemModel
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ShopNavModel
 */
export interface ShopNavModel extends ComponentModel {
    /**
     * 
     * @type {Array<ShopNavItemModel>}
     * @memberof ShopNavModel
     */
    'items'?: Array<ShopNavItemModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof ShopNavModel
     */
    'header'?: HeaderModel;
}
/**
 * 
 * @export
 * @interface SimpleItemCarouselGridAllOfModel
 */
export interface SimpleItemCarouselGridAllOfModel {
    /**
     * 
     * @type {Array<SimpleItemModel>}
     * @memberof SimpleItemCarouselGridAllOfModel
     */
    'items'?: Array<SimpleItemModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof SimpleItemCarouselGridAllOfModel
     */
    'header'?: HeaderModel;
}
/**
 * 
 * @export
 * @interface SimpleItemCarouselGridModel
 */
export interface SimpleItemCarouselGridModel extends ComponentModel {
    /**
     * 
     * @type {Array<SimpleItemModel>}
     * @memberof SimpleItemCarouselGridModel
     */
    'items'?: Array<SimpleItemModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof SimpleItemCarouselGridModel
     */
    'header'?: HeaderModel;
}
/**
 * 
 * @export
 * @interface SimpleItemCarouselItemModel
 */
export interface SimpleItemCarouselItemModel extends ComponentModel {
    /**
     * 
     * @type {Array<SimpleItemModel>}
     * @memberof SimpleItemCarouselItemModel
     */
    'items'?: Array<SimpleItemModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof SimpleItemCarouselItemModel
     */
    'header'?: HeaderModel;
}
/**
 * 
 * @export
 * @interface SimpleItemModel
 */
export interface SimpleItemModel {
    /**
     * 
     * @type {AnalyticsModel}
     * @memberof SimpleItemModel
     */
    'analytics': AnalyticsModel;
    /**
     * 
     * @type {string}
     * @memberof SimpleItemModel
     */
    'id': string;
    /**
     * 
     * @type {ImagesModel}
     * @memberof SimpleItemModel
     */
    'images'?: ImagesModel;
    /**
     * 
     * @type {string}
     * @memberof SimpleItemModel
     */
    'itemName'?: string;
    /**
     * 
     * @type {LinkModel}
     * @memberof SimpleItemModel
     */
    'link'?: LinkModel;
    /**
     * 
     * @type {string}
     * @memberof SimpleItemModel
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface SkuModel
 */
export interface SkuModel {
    /**
     * 
     * @type {string}
     * @memberof SkuModel
     */
    'dataSource'?: SkuModelDataSourceEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SkuModel
     */
    'monetized'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SkuModel
     */
    'sku'?: string;
}

export const SkuModelDataSourceEnum = {
    Manual: 'MANUAL',
    SegmentedPromoService: 'SEGMENTED_PROMO_SERVICE',
    VirtualBundleService: 'VIRTUAL_BUNDLE_SERVICE',
    Ruleset: 'RULESET',
    Pcm: 'PCM'
} as const;

export type SkuModelDataSourceEnum = typeof SkuModelDataSourceEnum[keyof typeof SkuModelDataSourceEnum];

/**
 * 
 * @export
 * @interface StandardBannerAllOfModel
 */
export interface StandardBannerAllOfModel {
    /**
     * 
     * @type {string}
     * @memberof StandardBannerAllOfModel
     */
    'accLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardBannerAllOfModel
     */
    'altText'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StandardBannerAllOfModel
     */
    'assetToggle'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StandardBannerAllOfModel
     */
    'bannerType'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardBannerAllOfModel
     * @deprecated
     */
    'contentAlignment'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardBannerAllOfModel
     */
    'contentHorizontalAlignment'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardBannerAllOfModel
     */
    'contentVerticalAlignment'?: string;
    /**
     * 
     * @type {Array<ButtonModel>}
     * @memberof StandardBannerAllOfModel
     */
    'ctas'?: Array<ButtonModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof StandardBannerAllOfModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {string}
     * @memberof StandardBannerAllOfModel
     */
    'headerTag'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardBannerAllOfModel
     */
    'height'?: string;
    /**
     * 
     * @type {ImagesModel}
     * @memberof StandardBannerAllOfModel
     */
    'images'?: ImagesModel;
    /**
     * 
     * @type {LinkModel}
     * @memberof StandardBannerAllOfModel
     */
    'link'?: LinkModel;
    /**
     * 
     * @type {CopyModel}
     * @memberof StandardBannerAllOfModel
     */
    'subText'?: CopyModel;
    /**
     * 
     * @type {string}
     * @memberof StandardBannerAllOfModel
     */
    'textAlignment'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardBannerAllOfModel
     */
    'textStyles'?: string;
    /**
     * 
     * @type {CopyModel}
     * @memberof StandardBannerAllOfModel
     */
    'topLine'?: CopyModel;
}
/**
 * 
 * @export
 * @interface StandardBannerCarouselAllOfModel
 */
export interface StandardBannerCarouselAllOfModel {
    /**
     * 
     * @type {Array<StandardBannerModel>}
     * @memberof StandardBannerCarouselAllOfModel
     */
    'items'?: Array<StandardBannerModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof StandardBannerCarouselAllOfModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {number}
     * @memberof StandardBannerCarouselAllOfModel
     */
    'slideInterval'?: number;
}
/**
 * 
 * @export
 * @interface StandardBannerCarouselModel
 */
export interface StandardBannerCarouselModel extends ComponentModel {
    /**
     * 
     * @type {Array<StandardBannerModel>}
     * @memberof StandardBannerCarouselModel
     */
    'items'?: Array<StandardBannerModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof StandardBannerCarouselModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {number}
     * @memberof StandardBannerCarouselModel
     */
    'slideInterval'?: number;
}
/**
 * 
 * @export
 * @interface StandardBannerModel
 */
export interface StandardBannerModel extends ComponentModel {
    /**
     * 
     * @type {string}
     * @memberof StandardBannerModel
     */
    'accLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardBannerModel
     */
    'altText'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StandardBannerModel
     */
    'assetToggle'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StandardBannerModel
     */
    'bannerType'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardBannerModel
     * @deprecated
     */
    'contentAlignment'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardBannerModel
     */
    'contentHorizontalAlignment'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardBannerModel
     */
    'contentVerticalAlignment'?: string;
    /**
     * 
     * @type {Array<ButtonModel>}
     * @memberof StandardBannerModel
     */
    'ctas'?: Array<ButtonModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof StandardBannerModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {string}
     * @memberof StandardBannerModel
     */
    'headerTag'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardBannerModel
     */
    'height'?: string;
    /**
     * 
     * @type {ImagesModel}
     * @memberof StandardBannerModel
     */
    'images'?: ImagesModel;
    /**
     * 
     * @type {LinkModel}
     * @memberof StandardBannerModel
     */
    'link'?: LinkModel;
    /**
     * 
     * @type {CopyModel}
     * @memberof StandardBannerModel
     */
    'subText'?: CopyModel;
    /**
     * 
     * @type {string}
     * @memberof StandardBannerModel
     */
    'textAlignment'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardBannerModel
     */
    'textStyles'?: string;
    /**
     * 
     * @type {CopyModel}
     * @memberof StandardBannerModel
     */
    'topLine'?: CopyModel;
}
/**
 * 
 * @export
 * @interface StandardBlogCardAllOfModel
 */
export interface StandardBlogCardAllOfModel {
    /**
     * 
     * @type {Array<StandardBlogCardItemModel>}
     * @memberof StandardBlogCardAllOfModel
     */
    'items'?: Array<StandardBlogCardItemModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof StandardBlogCardAllOfModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {boolean}
     * @memberof StandardBlogCardAllOfModel
     */
    'isMobile'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StandardBlogCardAllOfModel
     */
    'layout'?: string;
    /**
     * 
     * @type {CopyModel}
     * @memberof StandardBlogCardAllOfModel
     */
    'smallText'?: CopyModel;
    /**
     * 
     * @type {HeaderModel}
     * @memberof StandardBlogCardAllOfModel
     */
    'subHeader'?: HeaderModel;
    /**
     * 
     * @type {string}
     * @memberof StandardBlogCardAllOfModel
     */
    'tag'?: string;
}
/**
 * 
 * @export
 * @interface StandardBlogCardItemModel
 */
export interface StandardBlogCardItemModel {
    /**
     * 
     * @type {string}
     * @memberof StandardBlogCardItemModel
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardBlogCardItemModel
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardBlogCardItemModel
     */
    'link'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardBlogCardItemModel
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardBlogCardItemModel
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface StandardBlogCardModel
 */
export interface StandardBlogCardModel extends ComponentModel {
    /**
     * 
     * @type {Array<StandardBlogCardItemModel>}
     * @memberof StandardBlogCardModel
     */
    'items'?: Array<StandardBlogCardItemModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof StandardBlogCardModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {boolean}
     * @memberof StandardBlogCardModel
     */
    'isMobile'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StandardBlogCardModel
     */
    'layout'?: string;
    /**
     * 
     * @type {CopyModel}
     * @memberof StandardBlogCardModel
     */
    'smallText'?: CopyModel;
    /**
     * 
     * @type {HeaderModel}
     * @memberof StandardBlogCardModel
     */
    'subHeader'?: HeaderModel;
    /**
     * 
     * @type {string}
     * @memberof StandardBlogCardModel
     */
    'tag'?: string;
}
/**
 * 
 * @export
 * @interface StandardCardAllOfModel
 */
export interface StandardCardAllOfModel {
    /**
     * 
     * @type {string}
     * @memberof StandardCardAllOfModel
     */
    'backgroundColor'?: string;
    /**
     * 
     * @type {CopyModel}
     * @memberof StandardCardAllOfModel
     */
    'body'?: CopyModel;
    /**
     * 
     * @type {CopyModel}
     * @memberof StandardCardAllOfModel
     */
    'headline'?: CopyModel;
    /**
     * 
     * @type {ImagesModel}
     * @memberof StandardCardAllOfModel
     */
    'images'?: ImagesModel;
    /**
     * 
     * @type {LinkModel}
     * @memberof StandardCardAllOfModel
     */
    'link'?: LinkModel;
    /**
     * 
     * @type {CopyModel}
     * @memberof StandardCardAllOfModel
     */
    'source'?: CopyModel;
}
/**
 * 
 * @export
 * @interface StandardCardModel
 */
export interface StandardCardModel extends ComponentModel {
    /**
     * 
     * @type {string}
     * @memberof StandardCardModel
     */
    'backgroundColor'?: string;
    /**
     * 
     * @type {CopyModel}
     * @memberof StandardCardModel
     */
    'body'?: CopyModel;
    /**
     * 
     * @type {CopyModel}
     * @memberof StandardCardModel
     */
    'headline'?: CopyModel;
    /**
     * 
     * @type {ImagesModel}
     * @memberof StandardCardModel
     */
    'images'?: ImagesModel;
    /**
     * 
     * @type {LinkModel}
     * @memberof StandardCardModel
     */
    'link'?: LinkModel;
    /**
     * 
     * @type {CopyModel}
     * @memberof StandardCardModel
     */
    'source'?: CopyModel;
}
/**
 * 
 * @export
 * @interface StandardContentBlockAllOfModel
 */
export interface StandardContentBlockAllOfModel {
    /**
     * 
     * @type {Array<StandardContentBlockItemModel>}
     * @memberof StandardContentBlockAllOfModel
     */
    'items'?: Array<StandardContentBlockItemModel>;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockAllOfModel
     */
    'backgroundColor'?: string;
    /**
     * 
     * @type {ContentFooterModel}
     * @memberof StandardContentBlockAllOfModel
     */
    'footer'?: ContentFooterModel;
    /**
     * 
     * @type {HeaderModel}
     * @memberof StandardContentBlockAllOfModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockAllOfModel
     */
    'headerTag'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockAllOfModel
     */
    'layoutType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StandardContentBlockAllOfModel
     */
    'legacy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockAllOfModel
     */
    'marginBottom'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockAllOfModel
     */
    'marginTop'?: string;
    /**
     * 
     * @type {number}
     * @memberof StandardContentBlockAllOfModel
     */
    'numberOfColumns'?: number;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockAllOfModel
     */
    'orientationMobile'?: string;
    /**
     * 
     * @type {HeaderModel}
     * @memberof StandardContentBlockAllOfModel
     */
    'subHeader'?: HeaderModel;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockAllOfModel
     */
    'verticalAlignment'?: string;
}
/**
 * 
 * @export
 * @interface StandardContentBlockItemModel
 */
export interface StandardContentBlockItemModel {
    /**
     * 
     * @type {AnalyticsModel}
     * @memberof StandardContentBlockItemModel
     */
    'analytics': AnalyticsModel;
    /**
     * 
     * @type {Array<ButtonModel>}
     * @memberof StandardContentBlockItemModel
     */
    'ctas'?: Array<ButtonModel>;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockItemModel
     */
    'headerTag'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockItemModel
     */
    'horizontalAlignment'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockItemModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockItemModel
     */
    'imageSize'?: string;
    /**
     * 
     * @type {ImagesModel}
     * @memberof StandardContentBlockItemModel
     */
    'images'?: ImagesModel;
    /**
     * 
     * @type {InstrumentationModel}
     * @memberof StandardContentBlockItemModel
     */
    'instrumentation': InstrumentationModel;
    /**
     * 
     * @type {CopyModel}
     * @memberof StandardContentBlockItemModel
     */
    'itemHeader'?: CopyModel;
    /**
     * 
     * @type {CopyModel}
     * @memberof StandardContentBlockItemModel
     */
    'itemSubHeader'?: CopyModel;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockItemModel
     */
    'itemType'?: string;
    /**
     * 
     * @type {LinkModel}
     * @memberof StandardContentBlockItemModel
     */
    'link'?: LinkModel;
    /**
     * 
     * @type {MediaPlayerConfigModel}
     * @memberof StandardContentBlockItemModel
     */
    'mediaPlayerConfig'?: MediaPlayerConfigModel;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockItemModel
     */
    'padding'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockItemModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockItemModel
     */
    'wistiaId'?: string;
}
/**
 * 
 * @export
 * @interface StandardContentBlockModel
 */
export interface StandardContentBlockModel extends ComponentModel {
    /**
     * 
     * @type {Array<StandardContentBlockItemModel>}
     * @memberof StandardContentBlockModel
     */
    'items'?: Array<StandardContentBlockItemModel>;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockModel
     */
    'backgroundColor'?: string;
    /**
     * 
     * @type {ContentFooterModel}
     * @memberof StandardContentBlockModel
     */
    'footer'?: ContentFooterModel;
    /**
     * 
     * @type {HeaderModel}
     * @memberof StandardContentBlockModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockModel
     */
    'headerTag'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockModel
     */
    'layoutType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StandardContentBlockModel
     */
    'legacy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockModel
     */
    'marginBottom'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockModel
     */
    'marginTop'?: string;
    /**
     * 
     * @type {number}
     * @memberof StandardContentBlockModel
     */
    'numberOfColumns'?: number;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockModel
     */
    'orientationMobile'?: string;
    /**
     * 
     * @type {HeaderModel}
     * @memberof StandardContentBlockModel
     */
    'subHeader'?: HeaderModel;
    /**
     * 
     * @type {string}
     * @memberof StandardContentBlockModel
     */
    'verticalAlignment'?: string;
}
/**
 * 
 * @export
 * @interface StandardNonSkuAllOfModel
 */
export interface StandardNonSkuAllOfModel {
    /**
     * 
     * @type {Array<StandardNonSkuItemModel>}
     * @memberof StandardNonSkuAllOfModel
     */
    'items'?: Array<StandardNonSkuItemModel>;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuAllOfModel
     */
    'backgroundColor'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StandardNonSkuAllOfModel
     */
    'attributeTitles'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof StandardNonSkuAllOfModel
     */
    'displayAsLearnTabs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StandardNonSkuAllOfModel
     */
    'enableAttributes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StandardNonSkuAllOfModel
     */
    'enablePriceSnapshot'?: boolean;
    /**
     * 
     * @type {HeaderModel}
     * @memberof StandardNonSkuAllOfModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuAllOfModel
     */
    'imageCrop'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StandardNonSkuAllOfModel
     */
    'imageVeil'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuAllOfModel
     */
    'layoutType'?: string;
    /**
     * 
     * @type {LinkModel}
     * @memberof StandardNonSkuAllOfModel
     */
    'link'?: LinkModel;
    /**
     * 
     * @type {number}
     * @memberof StandardNonSkuAllOfModel
     */
    'maxItems'?: number;
    /**
     * 
     * @type {number}
     * @memberof StandardNonSkuAllOfModel
     */
    'minItems'?: number;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuAllOfModel
     */
    'orientationMobile'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuAllOfModel
     */
    'recipeType'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuAllOfModel
     */
    'shapeDescription'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StandardNonSkuAllOfModel
     */
    'shouldReplaceVSN'?: boolean;
    /**
     * 
     * @type {CopyModel}
     * @memberof StandardNonSkuAllOfModel
     */
    'subText'?: CopyModel;
    /**
     * 
     * @type {LinkModel}
     * @memberof StandardNonSkuAllOfModel
     */
    'subTitleLink'?: LinkModel;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuAllOfModel
     */
    'subTitleOptions'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuAllOfModel
     */
    'tileTitleTextSize'?: string;
    /**
     * 
     * @type {Array<ConstraintModel>}
     * @memberof StandardNonSkuAllOfModel
     */
    'constraints'?: Array<ConstraintModel>;
}
/**
 * 
 * @export
 * @interface StandardNonSkuItemModel
 */
export interface StandardNonSkuItemModel {
    /**
     * 
     * @type {AnalyticsModel}
     * @memberof StandardNonSkuItemModel
     */
    'analytics': AnalyticsModel;
    /**
     * 
     * @type {Array<string>}
     * @memberof StandardNonSkuItemModel
     */
    'attributeDescriptions': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuItemModel
     */
    'dynamicText'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuItemModel
     */
    'id': string;
    /**
     * 
     * @type {ImagesModel}
     * @memberof StandardNonSkuItemModel
     */
    'images'?: ImagesModel;
    /**
     * 
     * @type {InstrumentationModel}
     * @memberof StandardNonSkuItemModel
     */
    'instrumentation': InstrumentationModel;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuItemModel
     */
    'itemSubtitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuItemModel
     */
    'itemTitle'?: string;
    /**
     * 
     * @type {LinkModel}
     * @memberof StandardNonSkuItemModel
     */
    'link'?: LinkModel;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuItemModel
     */
    'priceRange'?: StandardNonSkuItemModelPriceRangeEnum;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuItemModel
     */
    'type': string;
}

export const StandardNonSkuItemModelPriceRangeEnum = {
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH'
} as const;

export type StandardNonSkuItemModelPriceRangeEnum = typeof StandardNonSkuItemModelPriceRangeEnum[keyof typeof StandardNonSkuItemModelPriceRangeEnum];

/**
 * 
 * @export
 * @interface StandardNonSkuModel
 */
export interface StandardNonSkuModel extends ComponentModel {
    /**
     * 
     * @type {Array<StandardNonSkuItemModel>}
     * @memberof StandardNonSkuModel
     */
    'items'?: Array<StandardNonSkuItemModel>;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuModel
     */
    'backgroundColor'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StandardNonSkuModel
     */
    'attributeTitles': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof StandardNonSkuModel
     */
    'displayAsLearnTabs': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StandardNonSkuModel
     */
    'enableAttributes': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StandardNonSkuModel
     */
    'enablePriceSnapshot': boolean;
    /**
     * 
     * @type {HeaderModel}
     * @memberof StandardNonSkuModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuModel
     */
    'imageCrop'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StandardNonSkuModel
     */
    'imageVeil'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuModel
     */
    'layoutType'?: string;
    /**
     * 
     * @type {LinkModel}
     * @memberof StandardNonSkuModel
     */
    'link'?: LinkModel;
    /**
     * 
     * @type {number}
     * @memberof StandardNonSkuModel
     */
    'maxItems'?: number;
    /**
     * 
     * @type {number}
     * @memberof StandardNonSkuModel
     */
    'minItems'?: number;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuModel
     */
    'orientationMobile'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuModel
     */
    'recipeType'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuModel
     */
    'shapeDescription'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StandardNonSkuModel
     */
    'shouldReplaceVSN': boolean;
    /**
     * 
     * @type {CopyModel}
     * @memberof StandardNonSkuModel
     */
    'subText'?: CopyModel;
    /**
     * 
     * @type {LinkModel}
     * @memberof StandardNonSkuModel
     */
    'subTitleLink'?: LinkModel;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuModel
     */
    'subTitleOptions'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardNonSkuModel
     */
    'tileTitleTextSize'?: string;
    /**
     * 
     * @type {Array<ConstraintModel>}
     * @memberof StandardNonSkuModel
     */
    'constraints': Array<ConstraintModel>;
}
/**
 * 
 * @export
 * @interface StandardPlaceholderAllOfModel
 */
export interface StandardPlaceholderAllOfModel {
    /**
     * 
     * @type {string}
     * @memberof StandardPlaceholderAllOfModel
     */
    'attributes'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardPlaceholderAllOfModel
     */
    'placeholderType'?: string;
}
/**
 * 
 * @export
 * @interface StandardPlaceholderModel
 */
export interface StandardPlaceholderModel extends ComponentModel {
    /**
     * 
     * @type {string}
     * @memberof StandardPlaceholderModel
     */
    'attributes'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardPlaceholderModel
     */
    'placeholderType'?: string;
}
/**
 * 
 * @export
 * @interface StandardSiteWideBannerAllOfModel
 */
export interface StandardSiteWideBannerAllOfModel {
    /**
     * 
     * @type {VectorGraphicModel}
     * @memberof StandardSiteWideBannerAllOfModel
     */
    'asset'?: VectorGraphicModel;
    /**
     * 
     * @type {string}
     * @memberof StandardSiteWideBannerAllOfModel
     */
    'assetPlacement'?: string;
    /**
     * 
     * @type {CopyModel}
     * @memberof StandardSiteWideBannerAllOfModel
     */
    'body'?: CopyModel;
    /**
     * 
     * @type {string}
     * @memberof StandardSiteWideBannerAllOfModel
     */
    'bodyText'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardSiteWideBannerAllOfModel
     */
    'bodyTextColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardSiteWideBannerAllOfModel
     */
    'ctaOptions'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardSiteWideBannerAllOfModel
     */
    'footnote'?: string;
    /**
     * 
     * @type {LogoIconModel}
     * @memberof StandardSiteWideBannerAllOfModel
     */
    'icon'?: LogoIconModel;
    /**
     * 
     * @type {ImagesModel}
     * @memberof StandardSiteWideBannerAllOfModel
     */
    'modalImages'?: ImagesModel;
    /**
     * 
     * @type {string}
     * @memberof StandardSiteWideBannerAllOfModel
     */
    'modalImageAltText'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardSiteWideBannerAllOfModel
     */
    'newPageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardSiteWideBannerAllOfModel
     */
    'recipeType'?: string;
    /**
     * 
     * @type {ContentThemeModel}
     * @memberof StandardSiteWideBannerAllOfModel
     */
    'theme'?: ContentThemeModel;
}
/**
 * 
 * @export
 * @interface StandardSiteWideBannerModel
 */
export interface StandardSiteWideBannerModel extends ComponentModel {
    /**
     * 
     * @type {VectorGraphicModel}
     * @memberof StandardSiteWideBannerModel
     */
    'asset'?: VectorGraphicModel;
    /**
     * 
     * @type {string}
     * @memberof StandardSiteWideBannerModel
     */
    'assetPlacement'?: string;
    /**
     * 
     * @type {CopyModel}
     * @memberof StandardSiteWideBannerModel
     */
    'body'?: CopyModel;
    /**
     * 
     * @type {string}
     * @memberof StandardSiteWideBannerModel
     */
    'bodyText'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardSiteWideBannerModel
     */
    'bodyTextColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardSiteWideBannerModel
     */
    'ctaOptions'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardSiteWideBannerModel
     */
    'footnote'?: string;
    /**
     * 
     * @type {LogoIconModel}
     * @memberof StandardSiteWideBannerModel
     */
    'icon'?: LogoIconModel;
    /**
     * 
     * @type {ImagesModel}
     * @memberof StandardSiteWideBannerModel
     */
    'modalImages'?: ImagesModel;
    /**
     * 
     * @type {string}
     * @memberof StandardSiteWideBannerModel
     */
    'modalImageAltText'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardSiteWideBannerModel
     */
    'newPageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardSiteWideBannerModel
     */
    'recipeType'?: string;
    /**
     * 
     * @type {ContentThemeModel}
     * @memberof StandardSiteWideBannerModel
     */
    'theme'?: ContentThemeModel;
}
/**
 * 
 * @export
 * @interface StandardSkuAllOfModel
 */
export interface StandardSkuAllOfModel {
    /**
     * 
     * @type {Array<ProductModel>}
     * @memberof StandardSkuAllOfModel
     */
    'items'?: Array<ProductModel>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StandardSkuAllOfModel
     */
    'badges'?: Array<string>;
    /**
     * 
     * @type {Array<ConstraintModel>}
     * @memberof StandardSkuAllOfModel
     */
    'constraints'?: Array<ConstraintModel>;
    /**
     * 
     * @type {ContextCardModel}
     * @memberof StandardSkuAllOfModel
     */
    'contextCardConfig'?: ContextCardModel;
    /**
     * 
     * @type {CustomerInsightsModel}
     * @memberof StandardSkuAllOfModel
     */
    'customerInsights'?: CustomerInsightsModel;
    /**
     * 
     * @type {HeaderModel}
     * @memberof StandardSkuAllOfModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {string}
     * @memberof StandardSkuAllOfModel
     */
    'imageOrientation'?: string;
    /**
     * 
     * @type {LinkModel}
     * @memberof StandardSkuAllOfModel
     */
    'link'?: LinkModel;
    /**
     * 
     * @type {number}
     * @memberof StandardSkuAllOfModel
     */
    'maxItems'?: number;
    /**
     * 
     * @type {number}
     * @memberof StandardSkuAllOfModel
     */
    'minItems'?: number;
    /**
     * 
     * @type {string}
     * @memberof StandardSkuAllOfModel
     */
    'placementType'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StandardSkuAllOfModel
     */
    'prices'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StandardSkuAllOfModel
     */
    'recipeType'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardSkuAllOfModel
     */
    'dataSource'?: StandardSkuAllOfModelDataSourceEnum;
    /**
     * 
     * @type {boolean}
     * @memberof StandardSkuAllOfModel
     */
    'showAddToCartButton'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StandardSkuAllOfModel
     */
    'showBundleLabel'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StandardSkuAllOfModel
     */
    'showDealCount'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StandardSkuAllOfModel
     */
    'showFtasPrice'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StandardSkuAllOfModel
     */
    'showGuestFtasPrice'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StandardSkuAllOfModel
     */
    'showNumberOfReviews'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StandardSkuAllOfModel
     */
    'showProductDescription'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StandardSkuAllOfModel
     */
    'showStars'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StandardSkuAllOfModel
     */
    'skuTypeOption'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardSkuAllOfModel
     */
    'subType'?: StandardSkuAllOfModelSubTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof StandardSkuAllOfModel
     */
    'titleDetails'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof StandardSkuAllOfModel
     */
    'useSavingsBadge'?: boolean;
    /**
     * 
     * @type {Array<SkuModel>}
     * @memberof StandardSkuAllOfModel
     */
    'skus'?: Array<SkuModel>;
}

export const StandardSkuAllOfModelDataSourceEnum = {
    Manual: 'MANUAL',
    SegmentedPromoService: 'SEGMENTED_PROMO_SERVICE',
    VirtualBundleService: 'VIRTUAL_BUNDLE_SERVICE',
    Ruleset: 'RULESET',
    Pcm: 'PCM'
} as const;

export type StandardSkuAllOfModelDataSourceEnum = typeof StandardSkuAllOfModelDataSourceEnum[keyof typeof StandardSkuAllOfModelDataSourceEnum];
export const StandardSkuAllOfModelSubTypeEnum = {
    Basic: 'BASIC',
    Combo: 'COMBO'
} as const;

export type StandardSkuAllOfModelSubTypeEnum = typeof StandardSkuAllOfModelSubTypeEnum[keyof typeof StandardSkuAllOfModelSubTypeEnum];

/**
 * 
 * @export
 * @interface StandardSkuModel
 */
export interface StandardSkuModel extends ComponentModel {
    /**
     * 
     * @type {Array<ProductModel>}
     * @memberof StandardSkuModel
     */
    'items'?: Array<ProductModel>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StandardSkuModel
     */
    'badges'?: Array<string>;
    /**
     * 
     * @type {Array<ConstraintModel>}
     * @memberof StandardSkuModel
     */
    'constraints'?: Array<ConstraintModel>;
    /**
     * 
     * @type {ContextCardModel}
     * @memberof StandardSkuModel
     */
    'contextCardConfig'?: ContextCardModel;
    /**
     * 
     * @type {CustomerInsightsModel}
     * @memberof StandardSkuModel
     */
    'customerInsights'?: CustomerInsightsModel;
    /**
     * 
     * @type {HeaderModel}
     * @memberof StandardSkuModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {string}
     * @memberof StandardSkuModel
     */
    'imageOrientation'?: string;
    /**
     * 
     * @type {LinkModel}
     * @memberof StandardSkuModel
     */
    'link'?: LinkModel;
    /**
     * 
     * @type {number}
     * @memberof StandardSkuModel
     */
    'maxItems'?: number;
    /**
     * 
     * @type {number}
     * @memberof StandardSkuModel
     */
    'minItems'?: number;
    /**
     * 
     * @type {string}
     * @memberof StandardSkuModel
     */
    'placementType'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StandardSkuModel
     */
    'prices'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StandardSkuModel
     */
    'recipeType'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardSkuModel
     */
    'dataSource'?: StandardSkuModelDataSourceEnum;
    /**
     * 
     * @type {boolean}
     * @memberof StandardSkuModel
     */
    'showAddToCartButton'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StandardSkuModel
     */
    'showBundleLabel'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StandardSkuModel
     */
    'showDealCount': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StandardSkuModel
     */
    'showFtasPrice'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StandardSkuModel
     */
    'showGuestFtasPrice'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StandardSkuModel
     */
    'showNumberOfReviews'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StandardSkuModel
     */
    'showProductDescription'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StandardSkuModel
     */
    'showStars'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StandardSkuModel
     */
    'skuTypeOption'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandardSkuModel
     */
    'subType'?: StandardSkuModelSubTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof StandardSkuModel
     */
    'titleDetails'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof StandardSkuModel
     */
    'useSavingsBadge': boolean;
    /**
     * 
     * @type {Array<SkuModel>}
     * @memberof StandardSkuModel
     */
    'skus'?: Array<SkuModel>;
}

export const StandardSkuModelDataSourceEnum = {
    Manual: 'MANUAL',
    SegmentedPromoService: 'SEGMENTED_PROMO_SERVICE',
    VirtualBundleService: 'VIRTUAL_BUNDLE_SERVICE',
    Ruleset: 'RULESET',
    Pcm: 'PCM'
} as const;

export type StandardSkuModelDataSourceEnum = typeof StandardSkuModelDataSourceEnum[keyof typeof StandardSkuModelDataSourceEnum];
export const StandardSkuModelSubTypeEnum = {
    Basic: 'BASIC',
    Combo: 'COMBO'
} as const;

export type StandardSkuModelSubTypeEnum = typeof StandardSkuModelSubTypeEnum[keyof typeof StandardSkuModelSubTypeEnum];

/**
 * 
 * @export
 * @interface TileModel
 */
export interface TileModel {
    /**
     * 
     * @type {AnalyticsModel}
     * @memberof TileModel
     */
    'analytics': AnalyticsModel;
    /**
     * 
     * @type {string}
     * @memberof TileModel
     */
    'id': string;
    /**
     * 
     * @type {ImagesModel}
     * @memberof TileModel
     */
    'images'?: ImagesModel;
    /**
     * 
     * @type {LinkModel}
     * @memberof TileModel
     */
    'link'?: LinkModel;
    /**
     * 
     * @type {string}
     * @memberof TileModel
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface TileSetAllOfModel
 */
export interface TileSetAllOfModel {
    /**
     * 
     * @type {Array<TileModel>}
     * @memberof TileSetAllOfModel
     */
    'items'?: Array<TileModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof TileSetAllOfModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {boolean}
     * @memberof TileSetAllOfModel
     */
    'useDivider'?: boolean;
}
/**
 * 
 * @export
 * @interface TileSetModel
 */
export interface TileSetModel extends ComponentModel {
    /**
     * 
     * @type {Array<TileModel>}
     * @memberof TileSetModel
     */
    'items'?: Array<TileModel>;
    /**
     * 
     * @type {HeaderModel}
     * @memberof TileSetModel
     */
    'header'?: HeaderModel;
    /**
     * 
     * @type {boolean}
     * @memberof TileSetModel
     */
    'useDivider'?: boolean;
}
/**
 * 
 * @export
 * @interface VectorGraphicModel
 */
export interface VectorGraphicModel {
    /**
     * 
     * @type {string}
     * @memberof VectorGraphicModel
     */
    'iosDarkUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof VectorGraphicModel
     */
    'iosLightUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof VectorGraphicModel
     */
    'pdfDarkUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof VectorGraphicModel
     */
    'pdfLightUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof VectorGraphicModel
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof VectorGraphicModel
     */
    'svgMarkup'?: string;
    /**
     * 
     * @type {string}
     * @memberof VectorGraphicModel
     */
    'svgUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof VectorGraphicModel
     */
    'voiceOverText'?: string;
}
/**
 * 
 * @export
 * @interface VideoModel
 */
export interface VideoModel {
    /**
     * 
     * @type {MediaPlayerConfigModel}
     * @memberof VideoModel
     */
    'mediaPlayerConfig'?: MediaPlayerConfigModel;
    /**
     * 
     * @type {string}
     * @memberof VideoModel
     */
    'wistiaId'?: string;
}
/**
 * @type ZoneComponentsInnerModel
 * @export
 */
export type ZoneComponentsInnerModel = AccordionModel | AdTileSetModel | ArticleCarouselModel | ArticleItemModel | BannerCarouselModel | BannerModel | DeckModel | NoContentModel | ProductCarouselModel | ShopNavModel | SimpleItemCarouselGridModel | SimpleItemCarouselItemModel | StandardBannerCarouselModel | StandardBannerModel | StandardBlogCardModel | StandardCardModel | StandardContentBlockModel | StandardNonSkuModel | StandardPlaceholderModel | StandardSiteWideBannerModel | StandardSkuModel | TileSetModel;

/**
 * 
 * @export
 * @interface ZoneModel
 */
export interface ZoneModel {
    /**
     * 
     * @type {string}
     * @memberof ZoneModel
     */
    'activatedExperiment'?: string | null;
    /**
     * 
     * @type {Array<ZoneComponentsInnerModel>}
     * @memberof ZoneModel
     */
    'components': Array<ZoneComponentsInnerModel>;
    /**
     * 
     * @type {string}
     * @memberof ZoneModel
     */
    'created'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ZoneModel
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ZoneModel
     */
    'lastPublished'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ZoneModel
     */
    'lastUpdated'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ZoneModel
     */
    'order': number;
    /**
     * 
     * @type {string}
     * @memberof ZoneModel
     */
    'testVariantName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ZoneModel
     */
    'title'?: string | null;
}

/**
 * ContentApi - axios parameter creator
 * @export
 */
export const ContentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Fetch content for general page types
         * @param {string} generalType Used for specifying general page type
         * @param {string} [selectionKey] Used for filtering general page types further by criteria. Only supported by /general/types/ endpoint
         * @param {boolean} [shouldBeVerbose] Used for debugging
         * @param {boolean} [shouldExplain] Used for debugging
         * @param {number} [zoneRangeFrom] Used for mentioning zone start value in range
         * @param {number} [zoneRangeTo] Used for mentioning zone end value in range
         * @param {Array<string>} [widgetTypes] Used for filtering response for specific widget types
         * @param {string} [chewyInsights] Used to pass the ID Token for an unrecognized user
         * @param {string} [deviceId] Used to pass the device ID
         * @param {string} [chewyOverridesContentPreview] Used to pass the preview cookie
         * @param {string} [ticket] Used to pass the ID Token for the authenticated user
         * @param {string} [ajsAnonymousId] Used to pass the anonymous ID for a user
         * @param {string} [nmaLinkerId] Used to pass the NMA linker ID
         * @param {string} [nmaLinkerId2] Used to pass the fallback NMA linker ID
         * @param {string} [fpproId] Used to pass the FPPRO ID
         * @param {string} [at] Used to pass the \&#39;at\&#39; cookie
         * @param {string} [xChewyAuthIdToken] Used to pass the user’s ID Token beyond the UI-Backend for performance. Replaces the deprecated Commerce-Token.
         * @param {string} [xChewyInternal] Used to check is if the request comes from a Chewy internal IP or not
         * @param {string} [xChewyVisitorContext] Used to pass contextual data about a visitor to the site
         * @param {string} [xPageContext] Used to pass contextual data about a visitor within the context of a particular page
         * @param {string} [commercePersonalizationId] Used to pass Personalization ID Token by NMA. Use X-Personalization-ID instead.
         * @param {string} [xPersonalizationID] Used to pass the Personalization ID Token to be used for request routing and MAB testing
         * @param {string} [xRequestID] Used to pass Request ID that can be used for filtering logs and troubleshooting
         * @param {string} [userAgent] Used to pass the User-Agent header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralPage: async (generalType: string, selectionKey?: string, shouldBeVerbose?: boolean, shouldExplain?: boolean, zoneRangeFrom?: number, zoneRangeTo?: number, widgetTypes?: Array<string>, chewyInsights?: string, deviceId?: string, chewyOverridesContentPreview?: string, ticket?: string, ajsAnonymousId?: string, nmaLinkerId?: string, nmaLinkerId2?: string, fpproId?: string, at?: string, xChewyAuthIdToken?: string, xChewyInternal?: string, xChewyVisitorContext?: string, xPageContext?: string, commercePersonalizationId?: string, xPersonalizationID?: string, xRequestID?: string, userAgent?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generalType' is not null or undefined
            assertParamExists('getGeneralPage', 'generalType', generalType)
            const localVarPath = `/v1/pages/general/types/{generalType}`
                .replace(`{${"generalType"}}`, encodeURIComponent(String(generalType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (selectionKey !== undefined) {
                localVarQueryParameter['selectionKey'] = selectionKey;
            }

            if (shouldBeVerbose !== undefined) {
                localVarQueryParameter['shouldBeVerbose'] = shouldBeVerbose;
            }

            if (shouldExplain !== undefined) {
                localVarQueryParameter['shouldExplain'] = shouldExplain;
            }

            if (zoneRangeFrom !== undefined) {
                localVarQueryParameter['zoneRangeFrom'] = zoneRangeFrom;
            }

            if (zoneRangeTo !== undefined) {
                localVarQueryParameter['zoneRangeTo'] = zoneRangeTo;
            }

            if (widgetTypes) {
                localVarQueryParameter['widgetTypes'] = widgetTypes;
            }

            if (xChewyAuthIdToken != null) {
                localVarHeaderParameter['X-Chewy-Auth-Id-Token'] = String(xChewyAuthIdToken);
            }

            if (xChewyInternal != null) {
                localVarHeaderParameter['X-Chewy-Internal'] = String(xChewyInternal);
            }

            if (xChewyVisitorContext != null) {
                localVarHeaderParameter['X-Chewy-Visitor-Context'] = String(xChewyVisitorContext);
            }

            if (xPageContext != null) {
                localVarHeaderParameter['X-Page-Context'] = String(xPageContext);
            }

            if (commercePersonalizationId != null) {
                localVarHeaderParameter['Commerce-PersonalizationId'] = String(commercePersonalizationId);
            }

            if (xPersonalizationID != null) {
                localVarHeaderParameter['X-Personalization-ID'] = String(xPersonalizationID);
            }

            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }

            if (userAgent != null) {
                localVarHeaderParameter['User-Agent'] = String(userAgent);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch content by page type. Supported page types : plp, pdp, header, hp, nma-home, nma-health-v2
         * @param {string} pageType Used for specifying page type
         * @param {boolean} [shouldBeVerbose] Used for debugging
         * @param {boolean} [shouldExplain] Used for debugging
         * @param {number} [zoneRangeFrom] Used for mentioning zone start value in range
         * @param {number} [zoneRangeTo] Used for mentioning zone end value in range
         * @param {Array<string>} [widgetTypes] Used for filtering response for specific widget types
         * @param {string} [partNumbers] Used for specifying page numbers. Supported only for pdp page type. Expected format: &lt;ParentPartNumber,ChildPartNumber&gt;
         * @param {number} [categoryId] Used to specify Category Id for plp page type
         * @param {number} [salesCategoryId] Used to specify Category Id for plp page type. Use salesCategoryId instead
         * @param {string} [facetMapping] Querying by this field has been deprecated
         * @param {string} [searchTerms] Querying by this field has been deprecated
         * @param {string} [chewyInsights] Used to pass the ID Token for an unrecognized user
         * @param {string} [deviceId] Used to pass the device ID
         * @param {string} [chewyOverridesContentPreview] Used to pass the preview cookie
         * @param {string} [ticket] Used to pass the ID Token for the authenticated user
         * @param {string} [ajsAnonymousId] Used to pass the anonymous ID for a user
         * @param {string} [nmaLinkerId] Used to pass the NMA linker ID
         * @param {string} [nmaLinkerId2] Used to pass the fallback NMA linker ID
         * @param {string} [fpproId] Used to pass the FPPRO ID
         * @param {string} [at] Used to pass the \&#39;at\&#39; cookie
         * @param {string} [xChewyAuthIdToken] Used to pass the user’s ID Token beyond the UI-Backend for performance. Replaces the deprecated Commerce-Token.
         * @param {string} [xChewyInternal] Used to check is if the request comes from a Chewy internal IP or not
         * @param {string} [xChewyVisitorContext] Used to pass contextual data about a visitor to the site
         * @param {string} [xPageContext] Used to pass contextual data about a visitor within the context of a particular page
         * @param {string} [commercePersonalizationId] Used to pass Personalization ID Token by NMA. Use X-Personalization-ID instead.
         * @param {string} [xPersonalizationID] Used to pass the Personalization ID Token to be used for request routing and MAB testing
         * @param {string} [xRequestID] Used to pass Request ID that can be used for filtering logs and troubleshooting
         * @param {string} [userAgent] Used to pass the User-Agent header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPage: async (pageType: string, shouldBeVerbose?: boolean, shouldExplain?: boolean, zoneRangeFrom?: number, zoneRangeTo?: number, widgetTypes?: Array<string>, partNumbers?: string, categoryId?: number, salesCategoryId?: number, facetMapping?: string, searchTerms?: string, chewyInsights?: string, deviceId?: string, chewyOverridesContentPreview?: string, ticket?: string, ajsAnonymousId?: string, nmaLinkerId?: string, nmaLinkerId2?: string, fpproId?: string, at?: string, xChewyAuthIdToken?: string, xChewyInternal?: string, xChewyVisitorContext?: string, xPageContext?: string, commercePersonalizationId?: string, xPersonalizationID?: string, xRequestID?: string, userAgent?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageType' is not null or undefined
            assertParamExists('getPage', 'pageType', pageType)
            const localVarPath = `/v1/pages/{pageType}`
                .replace(`{${"pageType"}}`, encodeURIComponent(String(pageType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (shouldBeVerbose !== undefined) {
                localVarQueryParameter['shouldBeVerbose'] = shouldBeVerbose;
            }

            if (shouldExplain !== undefined) {
                localVarQueryParameter['shouldExplain'] = shouldExplain;
            }

            if (zoneRangeFrom !== undefined) {
                localVarQueryParameter['zoneRangeFrom'] = zoneRangeFrom;
            }

            if (zoneRangeTo !== undefined) {
                localVarQueryParameter['zoneRangeTo'] = zoneRangeTo;
            }

            if (widgetTypes) {
                localVarQueryParameter['widgetTypes'] = widgetTypes;
            }

            if (partNumbers !== undefined) {
                localVarQueryParameter['partNumbers'] = partNumbers;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (salesCategoryId !== undefined) {
                localVarQueryParameter['salesCategoryId'] = salesCategoryId;
            }

            if (facetMapping !== undefined) {
                localVarQueryParameter['facetMapping'] = facetMapping;
            }

            if (searchTerms !== undefined) {
                localVarQueryParameter['searchTerms'] = searchTerms;
            }

            if (xChewyAuthIdToken != null) {
                localVarHeaderParameter['X-Chewy-Auth-Id-Token'] = String(xChewyAuthIdToken);
            }

            if (xChewyInternal != null) {
                localVarHeaderParameter['X-Chewy-Internal'] = String(xChewyInternal);
            }

            if (xChewyVisitorContext != null) {
                localVarHeaderParameter['X-Chewy-Visitor-Context'] = String(xChewyVisitorContext);
            }

            if (xPageContext != null) {
                localVarHeaderParameter['X-Page-Context'] = String(xPageContext);
            }

            if (commercePersonalizationId != null) {
                localVarHeaderParameter['Commerce-PersonalizationId'] = String(commercePersonalizationId);
            }

            if (xPersonalizationID != null) {
                localVarHeaderParameter['X-Personalization-ID'] = String(xPersonalizationID);
            }

            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }

            if (userAgent != null) {
                localVarHeaderParameter['User-Agent'] = String(userAgent);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContentApi - functional programming interface
 * @export
 */
export const ContentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Fetch content for general page types
         * @param {string} generalType Used for specifying general page type
         * @param {string} [selectionKey] Used for filtering general page types further by criteria. Only supported by /general/types/ endpoint
         * @param {boolean} [shouldBeVerbose] Used for debugging
         * @param {boolean} [shouldExplain] Used for debugging
         * @param {number} [zoneRangeFrom] Used for mentioning zone start value in range
         * @param {number} [zoneRangeTo] Used for mentioning zone end value in range
         * @param {Array<string>} [widgetTypes] Used for filtering response for specific widget types
         * @param {string} [chewyInsights] Used to pass the ID Token for an unrecognized user
         * @param {string} [deviceId] Used to pass the device ID
         * @param {string} [chewyOverridesContentPreview] Used to pass the preview cookie
         * @param {string} [ticket] Used to pass the ID Token for the authenticated user
         * @param {string} [ajsAnonymousId] Used to pass the anonymous ID for a user
         * @param {string} [nmaLinkerId] Used to pass the NMA linker ID
         * @param {string} [nmaLinkerId2] Used to pass the fallback NMA linker ID
         * @param {string} [fpproId] Used to pass the FPPRO ID
         * @param {string} [at] Used to pass the \&#39;at\&#39; cookie
         * @param {string} [xChewyAuthIdToken] Used to pass the user’s ID Token beyond the UI-Backend for performance. Replaces the deprecated Commerce-Token.
         * @param {string} [xChewyInternal] Used to check is if the request comes from a Chewy internal IP or not
         * @param {string} [xChewyVisitorContext] Used to pass contextual data about a visitor to the site
         * @param {string} [xPageContext] Used to pass contextual data about a visitor within the context of a particular page
         * @param {string} [commercePersonalizationId] Used to pass Personalization ID Token by NMA. Use X-Personalization-ID instead.
         * @param {string} [xPersonalizationID] Used to pass the Personalization ID Token to be used for request routing and MAB testing
         * @param {string} [xRequestID] Used to pass Request ID that can be used for filtering logs and troubleshooting
         * @param {string} [userAgent] Used to pass the User-Agent header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeneralPage(generalType: string, selectionKey?: string, shouldBeVerbose?: boolean, shouldExplain?: boolean, zoneRangeFrom?: number, zoneRangeTo?: number, widgetTypes?: Array<string>, chewyInsights?: string, deviceId?: string, chewyOverridesContentPreview?: string, ticket?: string, ajsAnonymousId?: string, nmaLinkerId?: string, nmaLinkerId2?: string, fpproId?: string, at?: string, xChewyAuthIdToken?: string, xChewyInternal?: string, xChewyVisitorContext?: string, xPageContext?: string, commercePersonalizationId?: string, xPersonalizationID?: string, xRequestID?: string, userAgent?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentPageModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneralPage(generalType, selectionKey, shouldBeVerbose, shouldExplain, zoneRangeFrom, zoneRangeTo, widgetTypes, chewyInsights, deviceId, chewyOverridesContentPreview, ticket, ajsAnonymousId, nmaLinkerId, nmaLinkerId2, fpproId, at, xChewyAuthIdToken, xChewyInternal, xChewyVisitorContext, xPageContext, commercePersonalizationId, xPersonalizationID, xRequestID, userAgent, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Fetch content by page type. Supported page types : plp, pdp, header, hp, nma-home, nma-health-v2
         * @param {string} pageType Used for specifying page type
         * @param {boolean} [shouldBeVerbose] Used for debugging
         * @param {boolean} [shouldExplain] Used for debugging
         * @param {number} [zoneRangeFrom] Used for mentioning zone start value in range
         * @param {number} [zoneRangeTo] Used for mentioning zone end value in range
         * @param {Array<string>} [widgetTypes] Used for filtering response for specific widget types
         * @param {string} [partNumbers] Used for specifying page numbers. Supported only for pdp page type. Expected format: &lt;ParentPartNumber,ChildPartNumber&gt;
         * @param {number} [categoryId] Used to specify Category Id for plp page type
         * @param {number} [salesCategoryId] Used to specify Category Id for plp page type. Use salesCategoryId instead
         * @param {string} [facetMapping] Querying by this field has been deprecated
         * @param {string} [searchTerms] Querying by this field has been deprecated
         * @param {string} [chewyInsights] Used to pass the ID Token for an unrecognized user
         * @param {string} [deviceId] Used to pass the device ID
         * @param {string} [chewyOverridesContentPreview] Used to pass the preview cookie
         * @param {string} [ticket] Used to pass the ID Token for the authenticated user
         * @param {string} [ajsAnonymousId] Used to pass the anonymous ID for a user
         * @param {string} [nmaLinkerId] Used to pass the NMA linker ID
         * @param {string} [nmaLinkerId2] Used to pass the fallback NMA linker ID
         * @param {string} [fpproId] Used to pass the FPPRO ID
         * @param {string} [at] Used to pass the \&#39;at\&#39; cookie
         * @param {string} [xChewyAuthIdToken] Used to pass the user’s ID Token beyond the UI-Backend for performance. Replaces the deprecated Commerce-Token.
         * @param {string} [xChewyInternal] Used to check is if the request comes from a Chewy internal IP or not
         * @param {string} [xChewyVisitorContext] Used to pass contextual data about a visitor to the site
         * @param {string} [xPageContext] Used to pass contextual data about a visitor within the context of a particular page
         * @param {string} [commercePersonalizationId] Used to pass Personalization ID Token by NMA. Use X-Personalization-ID instead.
         * @param {string} [xPersonalizationID] Used to pass the Personalization ID Token to be used for request routing and MAB testing
         * @param {string} [xRequestID] Used to pass Request ID that can be used for filtering logs and troubleshooting
         * @param {string} [userAgent] Used to pass the User-Agent header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPage(pageType: string, shouldBeVerbose?: boolean, shouldExplain?: boolean, zoneRangeFrom?: number, zoneRangeTo?: number, widgetTypes?: Array<string>, partNumbers?: string, categoryId?: number, salesCategoryId?: number, facetMapping?: string, searchTerms?: string, chewyInsights?: string, deviceId?: string, chewyOverridesContentPreview?: string, ticket?: string, ajsAnonymousId?: string, nmaLinkerId?: string, nmaLinkerId2?: string, fpproId?: string, at?: string, xChewyAuthIdToken?: string, xChewyInternal?: string, xChewyVisitorContext?: string, xPageContext?: string, commercePersonalizationId?: string, xPersonalizationID?: string, xRequestID?: string, userAgent?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentPageModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPage(pageType, shouldBeVerbose, shouldExplain, zoneRangeFrom, zoneRangeTo, widgetTypes, partNumbers, categoryId, salesCategoryId, facetMapping, searchTerms, chewyInsights, deviceId, chewyOverridesContentPreview, ticket, ajsAnonymousId, nmaLinkerId, nmaLinkerId2, fpproId, at, xChewyAuthIdToken, xChewyInternal, xChewyVisitorContext, xPageContext, commercePersonalizationId, xPersonalizationID, xRequestID, userAgent, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContentApi - factory interface
 * @export
 */
export const ContentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContentApiFp(configuration)
    return {
        /**
         * 
         * @summary Fetch content for general page types
         * @param {ContentApiGetGeneralPageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralPage(requestParameters: ContentApiGetGeneralPageRequest, options?: AxiosRequestConfig): AxiosPromise<ContentPageModel> {
            return localVarFp.getGeneralPage(requestParameters.generalType, requestParameters.selectionKey, requestParameters.shouldBeVerbose, requestParameters.shouldExplain, requestParameters.zoneRangeFrom, requestParameters.zoneRangeTo, requestParameters.widgetTypes, requestParameters.chewyInsights, requestParameters.deviceId, requestParameters.chewyOverridesContentPreview, requestParameters.ticket, requestParameters.ajsAnonymousId, requestParameters.nmaLinkerId, requestParameters.nmaLinkerId2, requestParameters.fpproId, requestParameters.at, requestParameters.xChewyAuthIdToken, requestParameters.xChewyInternal, requestParameters.xChewyVisitorContext, requestParameters.xPageContext, requestParameters.commercePersonalizationId, requestParameters.xPersonalizationID, requestParameters.xRequestID, requestParameters.userAgent, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch content by page type. Supported page types : plp, pdp, header, hp, nma-home, nma-health-v2
         * @param {ContentApiGetPageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPage(requestParameters: ContentApiGetPageRequest, options?: AxiosRequestConfig): AxiosPromise<ContentPageModel> {
            return localVarFp.getPage(requestParameters.pageType, requestParameters.shouldBeVerbose, requestParameters.shouldExplain, requestParameters.zoneRangeFrom, requestParameters.zoneRangeTo, requestParameters.widgetTypes, requestParameters.partNumbers, requestParameters.categoryId, requestParameters.salesCategoryId, requestParameters.facetMapping, requestParameters.searchTerms, requestParameters.chewyInsights, requestParameters.deviceId, requestParameters.chewyOverridesContentPreview, requestParameters.ticket, requestParameters.ajsAnonymousId, requestParameters.nmaLinkerId, requestParameters.nmaLinkerId2, requestParameters.fpproId, requestParameters.at, requestParameters.xChewyAuthIdToken, requestParameters.xChewyInternal, requestParameters.xChewyVisitorContext, requestParameters.xPageContext, requestParameters.commercePersonalizationId, requestParameters.xPersonalizationID, requestParameters.xRequestID, requestParameters.userAgent, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getGeneralPage operation in ContentApi.
 * @export
 * @interface ContentApiGetGeneralPageRequest
 */
export interface ContentApiGetGeneralPageRequest {
    /**
     * Used for specifying general page type
     * @type {string}
     * @memberof ContentApiGetGeneralPage
     */
    readonly generalType: string

    /**
     * Used for filtering general page types further by criteria. Only supported by /general/types/ endpoint
     * @type {string}
     * @memberof ContentApiGetGeneralPage
     */
    readonly selectionKey?: string

    /**
     * Used for debugging
     * @type {boolean}
     * @memberof ContentApiGetGeneralPage
     */
    readonly shouldBeVerbose?: boolean

    /**
     * Used for debugging
     * @type {boolean}
     * @memberof ContentApiGetGeneralPage
     */
    readonly shouldExplain?: boolean

    /**
     * Used for mentioning zone start value in range
     * @type {number}
     * @memberof ContentApiGetGeneralPage
     */
    readonly zoneRangeFrom?: number

    /**
     * Used for mentioning zone end value in range
     * @type {number}
     * @memberof ContentApiGetGeneralPage
     */
    readonly zoneRangeTo?: number

    /**
     * Used for filtering response for specific widget types
     * @type {Array<string>}
     * @memberof ContentApiGetGeneralPage
     */
    readonly widgetTypes?: Array<string>

    /**
     * Used to pass the ID Token for an unrecognized user
     * @type {string}
     * @memberof ContentApiGetGeneralPage
     */
    readonly chewyInsights?: string

    /**
     * Used to pass the device ID
     * @type {string}
     * @memberof ContentApiGetGeneralPage
     */
    readonly deviceId?: string

    /**
     * Used to pass the preview cookie
     * @type {string}
     * @memberof ContentApiGetGeneralPage
     */
    readonly chewyOverridesContentPreview?: string

    /**
     * Used to pass the ID Token for the authenticated user
     * @type {string}
     * @memberof ContentApiGetGeneralPage
     */
    readonly ticket?: string

    /**
     * Used to pass the anonymous ID for a user
     * @type {string}
     * @memberof ContentApiGetGeneralPage
     */
    readonly ajsAnonymousId?: string

    /**
     * Used to pass the NMA linker ID
     * @type {string}
     * @memberof ContentApiGetGeneralPage
     */
    readonly nmaLinkerId?: string

    /**
     * Used to pass the fallback NMA linker ID
     * @type {string}
     * @memberof ContentApiGetGeneralPage
     */
    readonly nmaLinkerId2?: string

    /**
     * Used to pass the FPPRO ID
     * @type {string}
     * @memberof ContentApiGetGeneralPage
     */
    readonly fpproId?: string

    /**
     * Used to pass the \&#39;at\&#39; cookie
     * @type {string}
     * @memberof ContentApiGetGeneralPage
     */
    readonly at?: string

    /**
     * Used to pass the user’s ID Token beyond the UI-Backend for performance. Replaces the deprecated Commerce-Token.
     * @type {string}
     * @memberof ContentApiGetGeneralPage
     */
    readonly xChewyAuthIdToken?: string

    /**
     * Used to check is if the request comes from a Chewy internal IP or not
     * @type {string}
     * @memberof ContentApiGetGeneralPage
     */
    readonly xChewyInternal?: string

    /**
     * Used to pass contextual data about a visitor to the site
     * @type {string}
     * @memberof ContentApiGetGeneralPage
     */
    readonly xChewyVisitorContext?: string

    /**
     * Used to pass contextual data about a visitor within the context of a particular page
     * @type {string}
     * @memberof ContentApiGetGeneralPage
     */
    readonly xPageContext?: string

    /**
     * Used to pass Personalization ID Token by NMA. Use X-Personalization-ID instead.
     * @type {string}
     * @memberof ContentApiGetGeneralPage
     */
    readonly commercePersonalizationId?: string

    /**
     * Used to pass the Personalization ID Token to be used for request routing and MAB testing
     * @type {string}
     * @memberof ContentApiGetGeneralPage
     */
    readonly xPersonalizationID?: string

    /**
     * Used to pass Request ID that can be used for filtering logs and troubleshooting
     * @type {string}
     * @memberof ContentApiGetGeneralPage
     */
    readonly xRequestID?: string

    /**
     * Used to pass the User-Agent header
     * @type {string}
     * @memberof ContentApiGetGeneralPage
     */
    readonly userAgent?: string
}

/**
 * Request parameters for getPage operation in ContentApi.
 * @export
 * @interface ContentApiGetPageRequest
 */
export interface ContentApiGetPageRequest {
    /**
     * Used for specifying page type
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly pageType: string

    /**
     * Used for debugging
     * @type {boolean}
     * @memberof ContentApiGetPage
     */
    readonly shouldBeVerbose?: boolean

    /**
     * Used for debugging
     * @type {boolean}
     * @memberof ContentApiGetPage
     */
    readonly shouldExplain?: boolean

    /**
     * Used for mentioning zone start value in range
     * @type {number}
     * @memberof ContentApiGetPage
     */
    readonly zoneRangeFrom?: number

    /**
     * Used for mentioning zone end value in range
     * @type {number}
     * @memberof ContentApiGetPage
     */
    readonly zoneRangeTo?: number

    /**
     * Used for filtering response for specific widget types
     * @type {Array<string>}
     * @memberof ContentApiGetPage
     */
    readonly widgetTypes?: Array<string>

    /**
     * Used for specifying page numbers. Supported only for pdp page type. Expected format: &lt;ParentPartNumber,ChildPartNumber&gt;
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly partNumbers?: string

    /**
     * Used to specify Category Id for plp page type
     * @type {number}
     * @memberof ContentApiGetPage
     */
    readonly categoryId?: number

    /**
     * Used to specify Category Id for plp page type. Use salesCategoryId instead
     * @type {number}
     * @memberof ContentApiGetPage
     */
    readonly salesCategoryId?: number

    /**
     * Querying by this field has been deprecated
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly facetMapping?: string

    /**
     * Querying by this field has been deprecated
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly searchTerms?: string

    /**
     * Used to pass the ID Token for an unrecognized user
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly chewyInsights?: string

    /**
     * Used to pass the device ID
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly deviceId?: string

    /**
     * Used to pass the preview cookie
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly chewyOverridesContentPreview?: string

    /**
     * Used to pass the ID Token for the authenticated user
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly ticket?: string

    /**
     * Used to pass the anonymous ID for a user
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly ajsAnonymousId?: string

    /**
     * Used to pass the NMA linker ID
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly nmaLinkerId?: string

    /**
     * Used to pass the fallback NMA linker ID
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly nmaLinkerId2?: string

    /**
     * Used to pass the FPPRO ID
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly fpproId?: string

    /**
     * Used to pass the \&#39;at\&#39; cookie
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly at?: string

    /**
     * Used to pass the user’s ID Token beyond the UI-Backend for performance. Replaces the deprecated Commerce-Token.
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly xChewyAuthIdToken?: string

    /**
     * Used to check is if the request comes from a Chewy internal IP or not
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly xChewyInternal?: string

    /**
     * Used to pass contextual data about a visitor to the site
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly xChewyVisitorContext?: string

    /**
     * Used to pass contextual data about a visitor within the context of a particular page
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly xPageContext?: string

    /**
     * Used to pass Personalization ID Token by NMA. Use X-Personalization-ID instead.
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly commercePersonalizationId?: string

    /**
     * Used to pass the Personalization ID Token to be used for request routing and MAB testing
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly xPersonalizationID?: string

    /**
     * Used to pass Request ID that can be used for filtering logs and troubleshooting
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly xRequestID?: string

    /**
     * Used to pass the User-Agent header
     * @type {string}
     * @memberof ContentApiGetPage
     */
    readonly userAgent?: string
}

/**
 * ContentApi - object-oriented interface
 * @export
 * @class ContentApi
 * @extends {BaseAPI}
 */
export class ContentApi extends BaseAPI {
    /**
     * 
     * @summary Fetch content for general page types
     * @param {ContentApiGetGeneralPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentApi
     */
    public getGeneralPage(requestParameters: ContentApiGetGeneralPageRequest, options?: AxiosRequestConfig) {
        return ContentApiFp(this.configuration).getGeneralPage(requestParameters.generalType, requestParameters.selectionKey, requestParameters.shouldBeVerbose, requestParameters.shouldExplain, requestParameters.zoneRangeFrom, requestParameters.zoneRangeTo, requestParameters.widgetTypes, requestParameters.chewyInsights, requestParameters.deviceId, requestParameters.chewyOverridesContentPreview, requestParameters.ticket, requestParameters.ajsAnonymousId, requestParameters.nmaLinkerId, requestParameters.nmaLinkerId2, requestParameters.fpproId, requestParameters.at, requestParameters.xChewyAuthIdToken, requestParameters.xChewyInternal, requestParameters.xChewyVisitorContext, requestParameters.xPageContext, requestParameters.commercePersonalizationId, requestParameters.xPersonalizationID, requestParameters.xRequestID, requestParameters.userAgent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch content by page type. Supported page types : plp, pdp, header, hp, nma-home, nma-health-v2
     * @param {ContentApiGetPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentApi
     */
    public getPage(requestParameters: ContentApiGetPageRequest, options?: AxiosRequestConfig) {
        return ContentApiFp(this.configuration).getPage(requestParameters.pageType, requestParameters.shouldBeVerbose, requestParameters.shouldExplain, requestParameters.zoneRangeFrom, requestParameters.zoneRangeTo, requestParameters.widgetTypes, requestParameters.partNumbers, requestParameters.categoryId, requestParameters.salesCategoryId, requestParameters.facetMapping, requestParameters.searchTerms, requestParameters.chewyInsights, requestParameters.deviceId, requestParameters.chewyOverridesContentPreview, requestParameters.ticket, requestParameters.ajsAnonymousId, requestParameters.nmaLinkerId, requestParameters.nmaLinkerId2, requestParameters.fpproId, requestParameters.at, requestParameters.xChewyAuthIdToken, requestParameters.xChewyInternal, requestParameters.xChewyVisitorContext, requestParameters.xPageContext, requestParameters.commercePersonalizationId, requestParameters.xPersonalizationID, requestParameters.xRequestID, requestParameters.userAgent, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PreviewApi - axios parameter creator
 * @export
 */
export const PreviewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Preview the requested page
         * @param {string} redirectPath The path on the site to preview
         * @param {string} [effectiveDate] The ISO-8601 representation of the date/time to preview
         * @param {'EN_US'} [locale] The locale to preview
         * @param {string} [pid] The Personalization ID to preview
         * @param {10} [siteId] The Site ID to preview
         * @param {Array<string>} [status] The status to preview
         * @param {number} [userId] The Customer ID to preview
         * @param {Array<string>} [audienceIds] The Audience ids to preview
         * @param {Array<string>} [treatmentIds] The treatments ids to preview
         * @param {string} [xChewyInternal] Used to check is if the request comes from a Chewy internal IP or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedirect: async (redirectPath: string, effectiveDate?: string, locale?: 'EN_US', pid?: string, siteId?: 10, status?: Array<string>, userId?: number, audienceIds?: Array<string>, treatmentIds?: Array<string>, xChewyInternal?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'redirectPath' is not null or undefined
            assertParamExists('getRedirect', 'redirectPath', redirectPath)
            const localVarPath = `/v1/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (redirectPath !== undefined) {
                localVarQueryParameter['redirectPath'] = redirectPath;
            }

            if (effectiveDate !== undefined) {
                localVarQueryParameter['effectiveDate'] = (effectiveDate as any instanceof Date) ?
                    (effectiveDate as any).toISOString() :
                    effectiveDate;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (pid !== undefined) {
                localVarQueryParameter['pid'] = pid;
            }

            if (siteId !== undefined) {
                localVarQueryParameter['siteId'] = siteId;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (audienceIds) {
                localVarQueryParameter['audienceIds'] = audienceIds;
            }

            if (treatmentIds) {
                localVarQueryParameter['treatmentIds'] = treatmentIds;
            }

            if (xChewyInternal != null) {
                localVarHeaderParameter['X-Chewy-Internal'] = String(xChewyInternal);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PreviewApi - functional programming interface
 * @export
 */
export const PreviewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PreviewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Preview the requested page
         * @param {string} redirectPath The path on the site to preview
         * @param {string} [effectiveDate] The ISO-8601 representation of the date/time to preview
         * @param {'EN_US'} [locale] The locale to preview
         * @param {string} [pid] The Personalization ID to preview
         * @param {10} [siteId] The Site ID to preview
         * @param {Array<string>} [status] The status to preview
         * @param {number} [userId] The Customer ID to preview
         * @param {Array<string>} [audienceIds] The Audience ids to preview
         * @param {Array<string>} [treatmentIds] The treatments ids to preview
         * @param {string} [xChewyInternal] Used to check is if the request comes from a Chewy internal IP or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRedirect(redirectPath: string, effectiveDate?: string, locale?: 'EN_US', pid?: string, siteId?: 10, status?: Array<string>, userId?: number, audienceIds?: Array<string>, treatmentIds?: Array<string>, xChewyInternal?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRedirect(redirectPath, effectiveDate, locale, pid, siteId, status, userId, audienceIds, treatmentIds, xChewyInternal, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PreviewApi - factory interface
 * @export
 */
export const PreviewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PreviewApiFp(configuration)
    return {
        /**
         * 
         * @summary Preview the requested page
         * @param {PreviewApiGetRedirectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedirect(requestParameters: PreviewApiGetRedirectRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getRedirect(requestParameters.redirectPath, requestParameters.effectiveDate, requestParameters.locale, requestParameters.pid, requestParameters.siteId, requestParameters.status, requestParameters.userId, requestParameters.audienceIds, requestParameters.treatmentIds, requestParameters.xChewyInternal, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getRedirect operation in PreviewApi.
 * @export
 * @interface PreviewApiGetRedirectRequest
 */
export interface PreviewApiGetRedirectRequest {
    /**
     * The path on the site to preview
     * @type {string}
     * @memberof PreviewApiGetRedirect
     */
    readonly redirectPath: string

    /**
     * The ISO-8601 representation of the date/time to preview
     * @type {string}
     * @memberof PreviewApiGetRedirect
     */
    readonly effectiveDate?: string

    /**
     * The locale to preview
     * @type {'EN_US'}
     * @memberof PreviewApiGetRedirect
     */
    readonly locale?: 'EN_US'

    /**
     * The Personalization ID to preview
     * @type {string}
     * @memberof PreviewApiGetRedirect
     */
    readonly pid?: string

    /**
     * The Site ID to preview
     * @type {10}
     * @memberof PreviewApiGetRedirect
     */
    readonly siteId?: 10

    /**
     * The status to preview
     * @type {Array<string>}
     * @memberof PreviewApiGetRedirect
     */
    readonly status?: Array<string>

    /**
     * The Customer ID to preview
     * @type {number}
     * @memberof PreviewApiGetRedirect
     */
    readonly userId?: number

    /**
     * The Audience ids to preview
     * @type {Array<string>}
     * @memberof PreviewApiGetRedirect
     */
    readonly audienceIds?: Array<string>

    /**
     * The treatments ids to preview
     * @type {Array<string>}
     * @memberof PreviewApiGetRedirect
     */
    readonly treatmentIds?: Array<string>

    /**
     * Used to check is if the request comes from a Chewy internal IP or not
     * @type {string}
     * @memberof PreviewApiGetRedirect
     */
    readonly xChewyInternal?: string
}

/**
 * PreviewApi - object-oriented interface
 * @export
 * @class PreviewApi
 * @extends {BaseAPI}
 */
export class PreviewApi extends BaseAPI {
    /**
     * 
     * @summary Preview the requested page
     * @param {PreviewApiGetRedirectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreviewApi
     */
    public getRedirect(requestParameters: PreviewApiGetRedirectRequest, options?: AxiosRequestConfig) {
        return PreviewApiFp(this.configuration).getRedirect(requestParameters.redirectPath, requestParameters.effectiveDate, requestParameters.locale, requestParameters.pid, requestParameters.siteId, requestParameters.status, requestParameters.userId, requestParameters.audienceIds, requestParameters.treatmentIds, requestParameters.xChewyInternal, options).then((request) => request(this.axios, this.basePath));
    }
}


